import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  VOID7hggqo3abtya as VOID,
  createThis2j2avj17cvnv2 as createThis,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  equals2au1ep9vhcato as equals,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  protoOf180f3jzyo7rfj as protoOf,
  Comparable198qfk8pnblz0 as Comparable,
  KtList3hktaavzmj137 as KtList,
  toSet2orjxp16sotqu as toSet,
  Collection1k04j3hzsbod0 as Collection,
  isInterface3d6p8outrmvmk as isInterface,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  isNaNymqb93xtq8w8 as isNaN_0,
  Unit_instanceat14thlj150z as Unit_instance,
  Enum3alwj03lh1n41 as Enum,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  contentEquals379bkuxwxaiqz as contentEquals,
  contentHashCode2dpr73siofp13 as contentHashCode,
  StringBuildermazzzhj6kkai as StringBuilder,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  coerceIn10f36k81le1mm as coerceIn,
  minOfmf6w75l7u1a7 as minOf,
  maxOf1m19db8qhkqy5 as maxOf,
} from './kotlin-kotlin-stdlib.mjs';
import {
  _Ratio___init__impl__9mwvn2xyj9fjgana63 as _Ratio___init__impl__9mwvn2,
  umod1d8wj61c81r0q as umod,
  isAlmostEquals2e7wogp48cvmj as isAlmostEquals,
  Ratio__toDouble_impl_o7epze2ppsc3gplivz8 as Ratio__toDouble_impl_o7epze,
  toRatio1hooqit5gulhr as toRatio,
  Ratio__times_impl_ucdh7y2x1w5kf040xma as Ratio__times_impl_ucdh7y,
  Ratio__compareTo_impl_z2iencsp0le8uhwq33 as Ratio__compareTo_impl_z2ienc,
  roundDecimalPlaces1x32iuyd1l8m5 as roundDecimalPlaces,
  get_niceStr3crhxydmlnaoj as get_niceStr,
  isAlmostEquals$default2ib7nwup21mfy as isAlmostEquals$default,
  IsAlmostEquals2vs54x7i426j2 as IsAlmostEquals,
  interpolate2g7wzskc23f1q as interpolate,
  interpolate35pbs3ac913y4 as interpolate_0,
  get_niceStr1tlwtz2l2j4my as get_niceStr_0,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
//region block: imports
var imul = Math.imul;
var hypot = Math.hypot;
//endregion
//region block: pre-declaration
class Companion {
  constructor() {
    Companion_instance = this;
    this.b29_1 = Anchor2D.m29(0.0, 0.0);
    this.c29_1 = Anchor2D.m29(0.5, 0.0);
    this.d29_1 = Anchor2D.m29(1.0, 0.0);
    this.e29_1 = Anchor2D.m29(0.0, 0.5);
    this.f29_1 = Anchor2D.m29(0.5, 0.5);
    this.g29_1 = Anchor2D.m29(1.0, 0.5);
    this.h29_1 = Anchor2D.m29(0.0, 1.0);
    this.i29_1 = Anchor2D.m29(0.5, 1.0);
    this.j29_1 = Anchor2D.m29(1.0, 1.0);
  }
  n29() {
    return this.f29_1;
  }
}
class Anchor2D {
  static o29(sx, sy) {
    Companion_getInstance();
    var $this = createThis(this);
    $this.k29_1 = sx;
    $this.l29_1 = sy;
    return $this;
  }
  static m29(sx, sy) {
    Companion_getInstance();
    return this.o29(sx, sy);
  }
  toString() {
    return 'Anchor2D(sx=' + this.k29_1 + ', sy=' + this.l29_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.k29_1);
    result = imul(result, 31) + getNumberHashCode(this.l29_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Anchor2D))
      return false;
    var tmp0_other_with_cast = other instanceof Anchor2D ? other : THROW_CCE();
    if (!equals(this.k29_1, tmp0_other_with_cast.k29_1))
      return false;
    if (!equals(this.l29_1, tmp0_other_with_cast.l29_1))
      return false;
    return true;
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_0 = this;
    var tmp = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    Companion_getInstance_0();
    var ratio = toRatio(1.0E-5);
    var tmp$ret$0 = Ratio__times_impl_ucdh7y(ratio, 6.283185307179586);
    tmp.q29_1 = _Angle___init__impl__g23q1m(tmp$ret$0);
    var tmp_0 = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    Companion_getInstance_0();
    var ratio_0 = toRatio(0.0);
    var tmp$ret$2 = Ratio__times_impl_ucdh7y(ratio_0, 6.283185307179586);
    tmp_0.r29_1 = _Angle___init__impl__g23q1m(tmp$ret$2);
    var tmp_1 = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    Companion_getInstance_0();
    var ratio_1 = toRatio(0.25);
    var tmp$ret$4 = Ratio__times_impl_ucdh7y(ratio_1, 6.283185307179586);
    tmp_1.s29_1 = _Angle___init__impl__g23q1m(tmp$ret$4);
    var tmp_2 = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    Companion_getInstance_0();
    var ratio_2 = toRatio(0.5);
    var tmp$ret$6 = Ratio__times_impl_ucdh7y(ratio_2, 6.283185307179586);
    tmp_2.t29_1 = _Angle___init__impl__g23q1m(tmp$ret$6);
    var tmp_3 = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    Companion_getInstance_0();
    var ratio_3 = toRatio(0.75);
    var tmp$ret$8 = Ratio__times_impl_ucdh7y(ratio_3, 6.283185307179586);
    tmp_3.u29_1 = _Angle___init__impl__g23q1m(tmp$ret$8);
    var tmp_4 = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    Companion_getInstance_0();
    var ratio_4 = toRatio(1.0);
    var tmp$ret$10 = Ratio__times_impl_ucdh7y(ratio_4, 6.283185307179586);
    tmp_4.v29_1 = _Angle___init__impl__g23q1m(tmp$ret$10);
  }
}
class Angle {
  constructor(radians) {
    Companion_getInstance_0();
    this.p29_1 = radians;
  }
  w29(other, epsilon) {
    return Angle__isAlmostEquals_impl_201sgt(this.p29_1, other, epsilon);
  }
  cz(other, epsilon) {
    return Angle__isAlmostEquals_impl_201sgt_0(this, other, epsilon);
  }
  x29(other) {
    return Angle__compareTo_impl_a0hfds(this.p29_1, other);
  }
  d(other) {
    return Angle__compareTo_impl_a0hfds_0(this, other);
  }
  toString() {
    return Angle__toString_impl_786qky(this.p29_1);
  }
  hashCode() {
    return Angle__hashCode_impl_szcndt(this.p29_1);
  }
  equals(other) {
    return Angle__equals_impl_zcf5mt(this.p29_1, other);
  }
}
class Companion_1 {
  constructor() {
    Companion_instance_1 = this;
    this.v2a_1 = _BoundsBuilder___init__impl__g6dprh(Companion_getInstance_10().z2a());
  }
  a2b() {
    return this.v2a_1;
  }
  b2b(p1, p2, p3, p4) {
    return _BoundsBuilder___init__impl__g6dprh(Companion_getInstance_10().e2b(Companion_getInstance_15().c2b(p1, p2, p3, p4), Companion_getInstance_15().d2b(p1, p2, p3, p4)));
  }
}
class BoundsBuilder {
  constructor(bounds) {
    Companion_getInstance_1();
    this.n2b_1 = bounds;
  }
  toString() {
    return BoundsBuilder__toString_impl_fmvxh7(this.n2b_1);
  }
  hashCode() {
    return BoundsBuilder__hashCode_impl_649zbo(this.n2b_1);
  }
  equals(other) {
    return BoundsBuilder__equals_impl_jngfjs(this.n2b_1, other);
  }
}
class Companion_2 {}
class Circle {
  constructor(center, radius) {
    this.o2b_1 = center;
    this.p2b_1 = radius;
  }
  q2b() {
    return this.p2b_1 * this.p2b_1;
  }
  r2b(p) {
    return Companion_getInstance_15().s2b(p, this.o2b_1);
  }
  t2b(p) {
    return this.r2b(p) - this.q2b();
  }
  u2b(p) {
    return this.r2b(p) + this.q2b();
  }
  toString() {
    return 'Circle(center=' + this.o2b_1.toString() + ', radius=' + this.p2b_1 + ')';
  }
  hashCode() {
    var result = this.o2b_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.p2b_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Circle))
      return false;
    var tmp0_other_with_cast = other instanceof Circle ? other : THROW_CCE();
    if (!this.o2b_1.equals(tmp0_other_with_cast.o2b_1))
      return false;
    if (!equals(this.p2b_1, tmp0_other_with_cast.p2b_1))
      return false;
    return true;
  }
}
class IPointList$Sublist$listIterator$1 {
  constructor($index, this$0) {
    this.w2b_1 = $index;
    this.x2b_1 = this$0;
    this.v2b_1 = $index;
  }
  c1() {
    return this.v2b_1 >= this.x2b_1.b2c_1;
  }
  d1() {
    var _unary__edvuaz = this.v2b_1;
    this.v2b_1 = _unary__edvuaz + 1 | 0;
    return this.x2b_1.e1(_unary__edvuaz);
  }
}
class Sublist {
  constructor(list, fromIndex, toIndex) {
    this.y2b_1 = list;
    this.z2b_1 = fromIndex;
    this.a2c_1 = toIndex;
    this.b2c_1 = this.a2c_1 - this.z2b_1 | 0;
  }
  f1() {
    return this.b2c_1;
  }
  e1(index) {
    return this.y2b_1.e1(index + this.z2b_1 | 0);
  }
  h1() {
    return this.b2c_1 === 0;
  }
  b1() {
    return this.a3();
  }
  a3() {
    return this.b3(0);
  }
  b3(index) {
    return new IPointList$Sublist$listIterator$1(index, this);
  }
  c3(fromIndex, toIndex) {
    return new Sublist(this.y2b_1, this.z2b_1 + fromIndex | 0, this.z2b_1 + toIndex | 0);
  }
  c2c(element) {
    return Companion_instance_3.d2c(this.y2b_1, element, this.z2b_1, this.a2c_1, -this.z2b_1 | 0);
  }
  z2(element) {
    if (!(element instanceof Vector2D))
      return -1;
    return this.c2c(element instanceof Vector2D ? element : THROW_CCE());
  }
  e2c(elements) {
    return Companion_instance_3.f2c(this, elements);
  }
  y2(elements) {
    return this.e2c(elements);
  }
  g2c(element) {
    return this.c2c(element) >= 0;
  }
  x2(element) {
    if (!(element instanceof Vector2D))
      return false;
    return this.g2c(element instanceof Vector2D ? element : THROW_CCE());
  }
}
class Companion_3 {
  f2c(_this__u8e3s4, elements) {
    var s = toSet(elements);
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(_this__u8e3s4, Collection)) {
        tmp = _this__u8e3s4.h1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var tmp0_iterator = _this__u8e3s4.b1();
      while (tmp0_iterator.c1()) {
        var element = tmp0_iterator.d1();
        // Inline function 'korlibs.math.geom.Companion.containsAllSet.<anonymous>' call
        if (!s.x2(element)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  d2c(list, element, fromIndex, toIndex, offset) {
    var inductionVariable = fromIndex;
    if (inductionVariable < toIndex)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (list.h2c(n) === element.a2a_1 && list.i2c(n) === element.b2a_1)
          return n + offset | 0;
      }
       while (inductionVariable < toIndex);
    return -1;
  }
  j2c(list, element, fromIndex, toIndex, offset, $super) {
    fromIndex = fromIndex === VOID ? 0 : fromIndex;
    toIndex = toIndex === VOID ? list.f1() : toIndex;
    offset = offset === VOID ? 0 : offset;
    return $super === VOID ? this.d2c(list, element, fromIndex, toIndex, offset) : $super.d2c.call(this, list, element, fromIndex, toIndex, offset);
  }
}
class IDoubleVectorList {}
function isNotEmpty() {
  return !(this.f1() === 0);
}
function isAlmostEquals_0(other, epsilon) {
  if (!(this.f1() === other.f1()))
    return false;
  if (!(this.o2c() === other.o2c()))
    return false;
  var inductionVariable = 0;
  var last = this.o2c();
  if (inductionVariable < last)
    do {
      var dim = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 0;
      var last_0 = this.f1();
      if (inductionVariable_0 < last_0)
        do {
          var n = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if (!isAlmostEquals(this.m2c(n, dim), other.m2c(n, dim), epsilon))
            return false;
        }
         while (inductionVariable_0 < last_0);
    }
     while (inductionVariable < last);
  return true;
}
class IPointList {}
function get(index) {
  return Vector2D.k2c(this.h2c(index), this.i2c(index));
}
function containsAll(elements) {
  return Companion_instance_3.f2c(this, elements);
}
function indexOf(element) {
  return Companion_instance_3.j2c(this, element);
}
function iterator() {
  return this.a3();
}
function listIterator() {
  return this.b3(0);
}
function listIterator_0(index) {
  return (new Sublist(this, 0, this.f1())).b3(index);
}
function subList(fromIndex, toIndex) {
  return new Sublist(this, fromIndex, toIndex);
}
class Companion_4 {
  constructor() {
    Companion_instance_4 = this;
    this.p2c_1 = Line2D.t2c(Companion_getInstance_15().c2a_1, Companion_getInstance_15().c2a_1);
    this.q2c_1 = Line2D.t2c(Companion_getInstance_15().d2a_1, Companion_getInstance_15().d2a_1);
  }
}
class Line2D {
  static t2c(a, b) {
    Companion_getInstance_4();
    var $this = createThis(this);
    $this.r2c_1 = a;
    $this.s2c_1 = b;
    return $this;
  }
  static u2c() {
    Companion_getInstance_4();
    return this.t2c(Vector2D.v2c(), Vector2D.v2c());
  }
  static w2c(x0, y0, x1, y1) {
    Companion_getInstance_4();
    return this.t2c(Vector2D.x2c(x0, y0), Vector2D.x2c(x1, y1));
  }
  y2c() {
    return this.r2c_1.a2a_1;
  }
  z2c() {
    return this.r2c_1.b2a_1;
  }
  a2d() {
    return this.s2c_1.a2a_1;
  }
  b2d() {
    return this.s2c_1.b2a_1;
  }
  toString() {
    return 'Line(' + this.r2c_1.toString() + ', ' + this.s2c_1.toString() + ')';
  }
  hashCode() {
    var result = this.r2c_1.hashCode();
    result = imul(result, 31) + this.s2c_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Line2D))
      return false;
    var tmp0_other_with_cast = other instanceof Line2D ? other : THROW_CCE();
    if (!this.r2c_1.equals(tmp0_other_with_cast.r2c_1))
      return false;
    if (!this.s2c_1.equals(tmp0_other_with_cast.s2c_1))
      return false;
    return true;
  }
}
class Companion_5 {
  constructor() {
    Companion_instance_5 = this;
    this.c2d_1 = MarginInt.h2d(0, 0, 0, 0);
  }
}
class MarginInt {
  static h2d(top, right, bottom, left) {
    Companion_getInstance_5();
    var $this = createThis(this);
    $this.d2d_1 = top;
    $this.e2d_1 = right;
    $this.f2d_1 = bottom;
    $this.g2d_1 = left;
    return $this;
  }
  static i2d(margin) {
    Companion_getInstance_5();
    return this.h2d(margin, margin, margin, margin);
  }
  j2d() {
    return !(this.d2d_1 === 0) || !(this.g2d_1 === 0) || !(this.e2d_1 === 0) || !(this.f2d_1 === 0);
  }
  k2d() {
    return this.g2d_1 + this.e2d_1 | 0;
  }
  l2d() {
    return this.d2d_1 + this.f2d_1 | 0;
  }
  toString() {
    return 'MarginInt(top=' + this.d2d_1 + ', right=' + this.e2d_1 + ', bottom=' + this.f2d_1 + ', left=' + this.g2d_1 + ')';
  }
  hashCode() {
    var result = this.d2d_1;
    result = imul(result, 31) + this.e2d_1 | 0;
    result = imul(result, 31) + this.f2d_1 | 0;
    result = imul(result, 31) + this.g2d_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MarginInt))
      return false;
    var tmp0_other_with_cast = other instanceof MarginInt ? other : THROW_CCE();
    if (!(this.d2d_1 === tmp0_other_with_cast.d2d_1))
      return false;
    if (!(this.e2d_1 === tmp0_other_with_cast.e2d_1))
      return false;
    if (!(this.f2d_1 === tmp0_other_with_cast.f2d_1))
      return false;
    if (!(this.g2d_1 === tmp0_other_with_cast.g2d_1))
      return false;
    return true;
  }
}
class Companion_6 {
  constructor() {
    Companion_instance_6 = this;
    this.m2d_1 = new Matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0);
    this.n2d_1 = new Matrix(NaN, NaN, NaN, NaN, NaN, NaN);
    this.o2d_1 = this.n2d_1;
  }
  p2d() {
    return this.m2d_1;
  }
  q2d(a, b, epsilon) {
    return isAlmostEquals(a.v2d_1, b.v2d_1, epsilon) && isAlmostEquals(a.w2d_1, b.w2d_1, epsilon) && isAlmostEquals(a.r2d_1, b.r2d_1, epsilon) && isAlmostEquals(a.s2d_1, b.s2d_1, epsilon) && isAlmostEquals(a.t2d_1, b.t2d_1, epsilon) && isAlmostEquals(a.u2d_1, b.u2d_1, epsilon);
  }
  x2d(l, r) {
    if (l.p2a())
      return r;
    if (r.p2a())
      return l;
    return new Matrix(l.r2d_1 * r.r2d_1 + l.s2d_1 * r.t2d_1, l.r2d_1 * r.s2d_1 + l.s2d_1 * r.u2d_1, l.t2d_1 * r.r2d_1 + l.u2d_1 * r.t2d_1, l.t2d_1 * r.s2d_1 + l.u2d_1 * r.u2d_1, l.v2d_1 * r.r2d_1 + l.w2d_1 * r.t2d_1 + r.v2d_1, l.v2d_1 * r.s2d_1 + l.w2d_1 * r.u2d_1 + r.w2d_1);
  }
  y2d(x, y, rotation, scaleX, scaleY, skewX, skewY, pivotX, pivotY) {
    // Inline function 'korlibs.math.geom.cos' call
    var angle = Angle__plus_impl_26v37k(rotation, skewY);
    var up = Companion_getInstance_15().g2a_1;
    var a = Angle__cosine_impl_bgvzun(angle, up) * scaleX + 0.0;
    // Inline function 'korlibs.math.geom.sin' call
    var angle_0 = Angle__plus_impl_26v37k(rotation, skewY);
    var up_0 = Companion_getInstance_15().g2a_1;
    var b = Angle__sine_impl_3l11xv(angle_0, up_0) * scaleX + 0.0;
    // Inline function 'korlibs.math.geom.sin' call
    var angle_1 = Angle__minus_impl_xeau7k(rotation, skewX);
    var up_1 = Companion_getInstance_15().g2a_1;
    var c = -Angle__sine_impl_3l11xv(angle_1, up_1) * scaleY + 0.0;
    // Inline function 'korlibs.math.geom.cos' call
    var angle_2 = Angle__minus_impl_xeau7k(rotation, skewX);
    var up_2 = Companion_getInstance_15().g2a_1;
    var d = Angle__cosine_impl_bgvzun(angle_2, up_2) * scaleY + 0.0;
    var tx;
    var ty;
    if (pivotX === 0.0 && pivotY === 0.0) {
      tx = x;
      ty = y;
    } else {
      tx = x - (pivotX * a + pivotY * c);
      ty = y - (pivotX * b + pivotY * d);
    }
    return new Matrix(a, b, c, d, tx, ty);
  }
  z2d(a, b, c, d, tx, ty, p) {
    return Vector2D.k2c(a * p.a2a_1 + c * p.b2a_1 + tx, d * p.b2a_1 + b * p.a2a_1 + ty);
  }
}
class Matrix {
  constructor(a, b, c, d, tx, ty) {
    Companion_getInstance_6();
    tx = tx === VOID ? 0.0 : tx;
    ty = ty === VOID ? 0.0 : ty;
    this.r2d_1 = a;
    this.s2d_1 = b;
    this.t2d_1 = c;
    this.u2d_1 = d;
    this.v2d_1 = tx;
    this.w2d_1 = ty;
  }
  a2e(other) {
    return Companion_getInstance_6().x2d(this, other);
  }
  p2a() {
    return isNaN_0(this.r2d_1);
  }
  q2a() {
    return !this.p2a();
  }
  b2e() {
    return this.r2d_1 === 1.0 && this.s2d_1 === 0.0 && this.t2d_1 === 0.0 && this.u2d_1 === 1.0 && this.v2d_1 === 0.0 && this.w2d_1 === 0.0;
  }
  c2e() {
    var hasRotation = !(this.s2d_1 === 0.0) || !(this.t2d_1 === 0.0);
    var hasScale = !(this.r2d_1 === 1.0) || !(this.u2d_1 === 1.0);
    var hasTranslation = !(this.v2d_1 === 0.0) || !(this.w2d_1 === 0.0);
    return hasRotation ? MatrixType_COMPLEX_getInstance() : hasScale && hasTranslation ? MatrixType_SCALE_TRANSLATE_getInstance() : hasScale ? MatrixType_SCALE_getInstance() : hasTranslation ? MatrixType_TRANSLATE_getInstance() : MatrixType_IDENTITY_getInstance();
  }
  d2e(p) {
    return this.e2e(p.a2a_1, p.b2a_1);
  }
  f2e(x, y) {
    return this.e2e(x, y);
  }
  g2e(x, y) {
    return this.h2e(x, y);
  }
  e2e(x, y) {
    return this.r2d_1 * x + this.t2d_1 * y + this.v2d_1;
  }
  h2e(x, y) {
    return this.u2d_1 * y + this.s2d_1 * x + this.w2d_1;
  }
  i2e(x, y) {
    return this.e2e(x, y);
  }
  j2e(x, y) {
    return this.h2e(x, y);
  }
  k2e(angle) {
    // Inline function 'korlibs.math.geom.cos' call
    var up = Companion_getInstance_15().g2a_1;
    var cos = Angle__cosine_impl_bgvzun(angle, up);
    // Inline function 'korlibs.math.geom.sin' call
    var up_0 = Companion_getInstance_15().g2a_1;
    var sin = Angle__sine_impl_3l11xv(angle, up_0);
    var a1 = this.r2d_1 * cos - this.s2d_1 * sin;
    var b = this.r2d_1 * sin + this.s2d_1 * cos;
    var a = a1;
    var c1 = this.t2d_1 * cos - this.u2d_1 * sin;
    var d = this.t2d_1 * sin + this.u2d_1 * cos;
    var c = c1;
    var tx1 = this.v2d_1 * cos - this.w2d_1 * sin;
    var ty = this.v2d_1 * sin + this.w2d_1 * cos;
    var tx = tx1;
    return new Matrix(a, b, c, d, tx, ty);
  }
  l2e(scaleX, scaleY) {
    return this.m2e(scaleX, scaleY);
  }
  m2e(scaleX, scaleY) {
    return new Matrix(this.r2d_1 * scaleX, this.s2d_1 * scaleX, this.t2d_1 * scaleY, this.u2d_1 * scaleY, this.v2d_1 * scaleX, this.w2d_1 * scaleY);
  }
  n2e(scaleX, scaleY, $super) {
    scaleY = scaleY === VOID ? scaleX : scaleY;
    return $super === VOID ? this.m2e(scaleX, scaleY) : $super.m2e.call(this, scaleX, scaleY);
  }
  o2e(scaleX, scaleY) {
    return new Matrix(this.r2d_1 * scaleX, this.s2d_1 * scaleX, this.t2d_1 * scaleY, this.u2d_1 * scaleY, this.v2d_1, this.w2d_1);
  }
  p2e(scaleX, scaleY, $super) {
    scaleY = scaleY === VOID ? scaleX : scaleY;
    return $super === VOID ? this.o2e(scaleX, scaleY) : $super.o2e.call(this, scaleX, scaleY);
  }
  q2e(delta) {
    return new Matrix(this.r2d_1, this.s2d_1, this.t2d_1, this.u2d_1, this.v2d_1 + delta.a2a_1, this.w2d_1 + delta.b2a_1);
  }
  r2e(x, y) {
    return this.q2e(Vector2D.x2c(x, y));
  }
  s2e(x, y) {
    return this.q2e(Vector2D.k2c(x, y));
  }
  t2e(delta) {
    return new Matrix(this.r2d_1, this.s2d_1, this.t2d_1, this.u2d_1, this.v2d_1 + (this.r2d_1 * delta.a2a_1 + this.t2d_1 * delta.b2a_1), this.w2d_1 + (this.s2d_1 * delta.a2a_1 + this.u2d_1 * delta.b2a_1));
  }
  u2e(deltaX, deltaY) {
    return this.t2e(Vector2D.v2e(deltaX, deltaY));
  }
  w2e(deltaX, deltaY) {
    return this.t2e(Vector2D.k2c(deltaX, deltaY));
  }
  x2e(m) {
    return m.a2e(this);
  }
  y2e() {
    if (this.p2a())
      return Companion_getInstance_6().m2d_1;
    var m = this;
    var norm = m.r2d_1 * m.u2d_1 - m.s2d_1 * m.t2d_1;
    var tmp;
    if (norm === 0.0) {
      tmp = new Matrix(0.0, 0.0, 0.0, 0.0, -m.v2d_1, -m.w2d_1);
    } else {
      var inorm = 1.0 / norm;
      var d = m.r2d_1 * inorm;
      var a = m.u2d_1 * inorm;
      var b = m.s2d_1 * -inorm;
      var c = m.t2d_1 * -inorm;
      tmp = new Matrix(a, b, c, d, -a * m.v2d_1 - c * m.w2d_1, -b * m.v2d_1 - d * m.w2d_1);
    }
    return tmp;
  }
  z2e() {
    return this.a2f();
  }
  a2f() {
    return Companion_getInstance_7().c2f(this);
  }
  toString() {
    return 'Matrix(' + get_niceStr(this.r2d_1) + ', ' + get_niceStr(this.s2d_1) + ', ' + get_niceStr(this.t2d_1) + ', ' + get_niceStr(this.u2d_1) + ', ' + get_niceStr(this.v2d_1) + ', ' + get_niceStr(this.w2d_1) + ')';
  }
  d2f(other, epsilon) {
    return Companion_getInstance_6().q2d(this, other, epsilon);
  }
  cz(other, epsilon) {
    return this.d2f(other instanceof Matrix ? other : THROW_CCE(), epsilon);
  }
  e2f(other) {
    return this.a2e(other);
  }
  hashCode() {
    var result = getNumberHashCode(this.r2d_1);
    result = imul(result, 31) + getNumberHashCode(this.s2d_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.t2d_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.u2d_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.v2d_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.w2d_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Matrix))
      return false;
    var tmp0_other_with_cast = other instanceof Matrix ? other : THROW_CCE();
    if (!equals(this.r2d_1, tmp0_other_with_cast.r2d_1))
      return false;
    if (!equals(this.s2d_1, tmp0_other_with_cast.s2d_1))
      return false;
    if (!equals(this.t2d_1, tmp0_other_with_cast.t2d_1))
      return false;
    if (!equals(this.u2d_1, tmp0_other_with_cast.u2d_1))
      return false;
    if (!equals(this.v2d_1, tmp0_other_with_cast.v2d_1))
      return false;
    if (!equals(this.w2d_1, tmp0_other_with_cast.w2d_1))
      return false;
    return true;
  }
}
class MatrixType extends Enum {
  constructor(name, ordinal, id, hasRotation, hasScale, hasTranslation) {
    super(name, ordinal);
    this.h2f_1 = id;
    this.i2f_1 = hasRotation;
    this.j2f_1 = hasScale;
    this.k2f_1 = hasTranslation;
  }
}
class Companion_7 {
  constructor() {
    Companion_instance_7 = this;
    this.b2f_1 = MatrixTransform.s2f(0.0, 0.0, 1.0, 1.0, Companion_getInstance_0().r29_1, Companion_getInstance_0().r29_1, Companion_getInstance_0().r29_1);
  }
  t2f(matrix, pivotX, pivotY) {
    var a = matrix.r2d_1;
    var b = matrix.s2d_1;
    var c = matrix.t2d_1;
    var d = matrix.u2d_1;
    // Inline function 'kotlin.math.atan2' call
    var y = -c;
    var skewX = -Math.atan2(y, d);
    // Inline function 'kotlin.math.atan2' call
    var skewY = Math.atan2(b, a);
    // Inline function 'kotlin.math.abs' call
    var x = skewX + skewY;
    var delta = Math.abs(x);
    var trotation;
    var tskewX;
    var tskewY;
    var tx;
    var ty;
    var tmp;
    if (delta < 0.001) {
      tmp = true;
    } else {
      // Inline function 'kotlin.math.abs' call
      var x_0 = 3.141592653589793 * 2 - delta;
      tmp = Math.abs(x_0) < 0.001;
    }
    if (tmp) {
      trotation = get_radians_0(skewY);
      tskewX = get_radians_0(0.0);
      tskewY = get_radians_0(0.0);
    } else {
      trotation = get_radians(0);
      tskewX = get_radians_0(skewX);
      tskewY = get_radians_0(skewY);
    }
    // Inline function 'kotlin.math.hypot' call
    var tscaleX = hypot(a, b);
    // Inline function 'kotlin.math.hypot' call
    var tscaleY = hypot(c, d);
    if (pivotX === 0.0 && pivotY === 0.0) {
      tx = matrix.v2d_1;
      ty = matrix.w2d_1;
    } else {
      tx = matrix.v2d_1 + (pivotX * a + pivotY * c);
      ty = matrix.w2d_1 + (pivotX * b + pivotY * d);
    }
    return MatrixTransform.s2f(tx, ty, tscaleX, tscaleY, tskewX, tskewY, trotation);
  }
  c2f(matrix, pivotX, pivotY, $super) {
    pivotX = pivotX === VOID ? 0.0 : pivotX;
    pivotY = pivotY === VOID ? 0.0 : pivotY;
    return $super === VOID ? this.t2f(matrix, pivotX, pivotY) : $super.t2f.call(this, matrix, pivotX, pivotY);
  }
  u2f(a, b, epsilon) {
    return isAlmostEquals(a.l2f_1, b.l2f_1, epsilon) && isAlmostEquals(a.m2f_1, b.m2f_1, epsilon) && isAlmostEquals(a.n2f_1, b.n2f_1, epsilon) && isAlmostEquals(a.o2f_1, b.o2f_1, epsilon) && Angle__isAlmostEquals_impl_201sgt(a.p2f_1, b.p2f_1, epsilon) && Angle__isAlmostEquals_impl_201sgt(a.q2f_1, b.q2f_1, epsilon) && Angle__isAlmostEquals_impl_201sgt(a.r2f_1, b.r2f_1, epsilon);
  }
}
class MatrixTransform {
  static s2f(x, y, scaleX, scaleY, skewX, skewY, rotation) {
    Companion_getInstance_7();
    x = x === VOID ? 0.0 : x;
    y = y === VOID ? 0.0 : y;
    scaleX = scaleX === VOID ? 1.0 : scaleX;
    scaleY = scaleY === VOID ? 1.0 : scaleY;
    skewX = skewX === VOID ? Companion_getInstance_0().r29_1 : skewX;
    skewY = skewY === VOID ? Companion_getInstance_0().r29_1 : skewY;
    rotation = rotation === VOID ? Companion_getInstance_0().r29_1 : rotation;
    var $this = createThis(this);
    $this.l2f_1 = x;
    $this.m2f_1 = y;
    $this.n2f_1 = scaleX;
    $this.o2f_1 = scaleY;
    $this.p2f_1 = skewX;
    $this.q2f_1 = skewY;
    $this.r2f_1 = rotation;
    return $this;
  }
  toString() {
    return 'MatrixTransform(x=' + get_niceStr(this.l2f_1) + ', y=' + get_niceStr(this.m2f_1) + ', scaleX=' + this.n2f_1 + ', scaleY=' + this.o2f_1 + ', skewX=' + Angle__toString_impl_786qky(this.p2f_1) + ', skewY=' + Angle__toString_impl_786qky(this.q2f_1) + ', rotation=' + Angle__toString_impl_786qky(this.r2f_1) + ')';
  }
  static v2f() {
    Companion_getInstance_7();
    return this.s2f(0.0, 0.0, 1.0, 1.0, Companion_getInstance_0().r29_1, Companion_getInstance_0().r29_1, Companion_getInstance_0().r29_1);
  }
  w2f(other, epsilon) {
    return Companion_getInstance_7().u2f(this, other, epsilon);
  }
  cz(other, epsilon) {
    return this.w2f(other instanceof MatrixTransform ? other : THROW_CCE(), epsilon);
  }
  x2f() {
    return (this.n2f_1 + this.o2f_1) * 0.5;
  }
  hashCode() {
    var result = getNumberHashCode(this.l2f_1);
    result = imul(result, 31) + getNumberHashCode(this.m2f_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.n2f_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.o2f_1) | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.p2f_1) | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.q2f_1) | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.r2f_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MatrixTransform))
      return false;
    var tmp0_other_with_cast = other instanceof MatrixTransform ? other : THROW_CCE();
    if (!equals(this.l2f_1, tmp0_other_with_cast.l2f_1))
      return false;
    if (!equals(this.m2f_1, tmp0_other_with_cast.m2f_1))
      return false;
    if (!equals(this.n2f_1, tmp0_other_with_cast.n2f_1))
      return false;
    if (!equals(this.o2f_1, tmp0_other_with_cast.o2f_1))
      return false;
    if (!equals(this.p2f_1, tmp0_other_with_cast.p2f_1))
      return false;
    if (!equals(this.q2f_1, tmp0_other_with_cast.q2f_1))
      return false;
    if (!equals(this.r2f_1, tmp0_other_with_cast.r2f_1))
      return false;
    return true;
  }
}
class Companion_8 {
  constructor() {
    Companion_instance_8 = this;
    this.y2f_1 = 0;
    this.z2f_1 = 1;
    this.a2g_1 = 2;
    this.b2g_1 = 3;
    this.c2g_1 = 4;
    this.d2g_1 = 5;
    this.e2g_1 = 6;
    this.f2g_1 = 7;
    this.g2g_1 = 8;
    this.h2g_1 = 9;
    this.i2g_1 = 10;
    this.j2g_1 = 11;
    this.k2g_1 = 12;
    this.l2g_1 = 13;
    this.m2g_1 = 14;
    this.n2g_1 = 15;
    var tmp = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp.o2g_1 = new Int32Array([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]);
    var tmp_0 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_0.p2g_1 = new Int32Array([0, 4, 8, 12, 1, 5, 9, 13, 2, 6, 10, 14, 3, 7, 11, 15]);
    var tmp_1 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_1.q2g_1 = new Int32Array([0, 1, 2, 4, 5, 6, 8, 9, 10]);
    var tmp_2 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_2.r2g_1 = new Int32Array([0, 4, 8, 1, 5, 9, 2, 6, 10]);
    this.s2g_1 = Matrix4.u2g();
  }
  v2g(v00, v01, v02, v03, v10, v11, v12, v13, v20, v21, v22, v23, v30, v31, v32, v33) {
    return Matrix4.w2g(v00, v10, v20, v30, v01, v11, v21, v31, v02, v12, v22, v32, v03, v13, v23, v33);
  }
  x2g(l, r) {
    return Companion_getInstance_8().v2g(l.y2g() * r.y2g() + l.z2g() * r.a2h() + l.b2h() * r.c2h() + l.d2h() * r.e2h(), l.y2g() * r.z2g() + l.z2g() * r.f2h() + l.b2h() * r.g2h() + l.d2h() * r.h2h(), l.y2g() * r.b2h() + l.z2g() * r.i2h() + l.b2h() * r.j2h() + l.d2h() * r.k2h(), l.y2g() * r.d2h() + l.z2g() * r.l2h() + l.b2h() * r.m2h() + l.d2h() * r.n2h(), l.a2h() * r.y2g() + l.f2h() * r.a2h() + l.i2h() * r.c2h() + l.l2h() * r.e2h(), l.a2h() * r.z2g() + l.f2h() * r.f2h() + l.i2h() * r.g2h() + l.l2h() * r.h2h(), l.a2h() * r.b2h() + l.f2h() * r.i2h() + l.i2h() * r.j2h() + l.l2h() * r.k2h(), l.a2h() * r.d2h() + l.f2h() * r.l2h() + l.i2h() * r.m2h() + l.l2h() * r.n2h(), l.c2h() * r.y2g() + l.g2h() * r.a2h() + l.j2h() * r.c2h() + l.m2h() * r.e2h(), l.c2h() * r.z2g() + l.g2h() * r.f2h() + l.j2h() * r.g2h() + l.m2h() * r.h2h(), l.c2h() * r.b2h() + l.g2h() * r.i2h() + l.j2h() * r.j2h() + l.m2h() * r.k2h(), l.c2h() * r.d2h() + l.g2h() * r.l2h() + l.j2h() * r.m2h() + l.m2h() * r.n2h(), l.e2h() * r.y2g() + l.h2h() * r.a2h() + l.k2h() * r.c2h() + l.n2h() * r.e2h(), l.e2h() * r.z2g() + l.h2h() * r.f2h() + l.k2h() * r.g2h() + l.n2h() * r.h2h(), l.e2h() * r.b2h() + l.h2h() * r.i2h() + l.k2h() * r.j2h() + l.n2h() * r.k2h(), l.e2h() * r.d2h() + l.h2h() * r.l2h() + l.k2h() * r.m2h() + l.n2h() * r.n2h());
  }
  o2h(left, right, bottom, top, near, far) {
    var sx = 2.0 / (right - left);
    var sy = 2.0 / (top - bottom);
    var sz = -2.0 / (far - near);
    var tx = -(right + left) / (right - left);
    var ty = -(top + bottom) / (top - bottom);
    var tz = -(far + near) / (far - near);
    return Companion_getInstance_8().v2g(sx, 0.0, 0.0, tx, 0.0, sy, 0.0, ty, 0.0, 0.0, sz, tz, 0.0, 0.0, 0.0, 1.0);
  }
  p2h(left, right, bottom, top, near, far) {
    return this.o2h(left, right, bottom, top, near, far);
  }
}
class Matrix4 {
  static q2h(data) {
    Companion_getInstance_8();
    var $this = createThis(this);
    $this.t2g_1 = data;
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!($this.t2g_1.length === 16)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.h5(toString(message));
    }
    return $this;
  }
  y2g() {
    return this.t2g_1[0];
  }
  a2h() {
    return this.t2g_1[1];
  }
  c2h() {
    return this.t2g_1[2];
  }
  e2h() {
    return this.t2g_1[3];
  }
  z2g() {
    return this.t2g_1[4];
  }
  f2h() {
    return this.t2g_1[5];
  }
  g2h() {
    return this.t2g_1[6];
  }
  h2h() {
    return this.t2g_1[7];
  }
  b2h() {
    return this.t2g_1[8];
  }
  i2h() {
    return this.t2g_1[9];
  }
  j2h() {
    return this.t2g_1[10];
  }
  k2h() {
    return this.t2g_1[11];
  }
  d2h() {
    return this.t2g_1[12];
  }
  l2h() {
    return this.t2g_1[13];
  }
  m2h() {
    return this.t2g_1[14];
  }
  n2h() {
    return this.t2g_1[15];
  }
  equals(other) {
    var tmp;
    if (other instanceof Matrix4) {
      tmp = contentEquals(this.t2g_1, other.t2g_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return contentHashCode(this.t2g_1);
  }
  r2h(that) {
    return Companion_getInstance_8().x2g(this, that);
  }
  static w2g(v00, v10, v20, v30, v01, v11, v21, v31, v02, v12, v22, v32, v03, v13, v23, v33) {
    Companion_getInstance_8();
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$0 = new Float32Array([v00, v10, v20, v30, v01, v11, v21, v31, v02, v12, v22, v32, v03, v13, v23, v33]);
    return this.q2h(tmp$ret$0);
  }
  static u2g() {
    Companion_getInstance_8();
    return this.w2g(1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0);
  }
  m2c(row, column) {
    if (!(0 <= column ? column <= 3 : false) || !(0 <= row ? row <= 3 : false)) {
      // Inline function 'kotlin.error' call
      var message = 'Invalid index ' + row + ',' + column;
      throw IllegalStateException.h5(toString(message));
    }
    return this.t2g_1[imul(row, 4) + column | 0];
  }
  s2h(index) {
    if (!(0 <= index ? index <= (this.t2g_1.length - 1 | 0) : false)) {
      // Inline function 'kotlin.error' call
      var message = 'Invalid index ' + index;
      throw IllegalStateException.h5(toString(message));
    }
    return this.t2g_1[index];
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.Matrix4.toString.<anonymous>' call
    this_0.bc('Matrix4(\n');
    var inductionVariable = 0;
    if (inductionVariable < 4)
      do {
        var row = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this_0.bc('  [ ');
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < 4)
          do {
            var col = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            if (!(col === 0)) {
              this_0.bc(', ');
            }
            var v = this.m2c(row, col);
            // Inline function 'kotlin.math.floor' call
            if (Math.floor(v) === v)
              this_0.ah(numberToInt(v));
            else {
              this_0.ch(v);
            }
          }
           while (inductionVariable_0 < 4);
        this_0.bc(' ],\n');
      }
       while (inductionVariable < 4);
    this_0.bc(')');
    return this_0.toString();
  }
}
class Companion_9 {
  constructor() {
    this.y29_1 = 1.0E-7;
  }
  z29(up) {
    // Inline function 'kotlin.check' call
    var tmp;
    if (up.a2a_1 === 0.0) {
      // Inline function 'kotlin.math.absoluteValue' call
      var this_0 = up.b2a_1;
      tmp = Math.abs(this_0) === 1.0;
    } else {
      tmp = false;
    }
    // Inline function 'kotlin.contracts.contract' call
    if (!tmp) {
      // Inline function 'korlibs.math.geom.Companion.checkValidUpVector.<anonymous>' call
      var message = 'up vector only supports (0, -1) and (0, +1) for now';
      throw IllegalStateException.h5(toString(message));
    }
  }
}
class Orientation extends Enum {
  constructor(name, ordinal, value) {
    super(name, ordinal);
    this.y2h_1 = value;
  }
}
class Companion_10 {
  constructor() {
    Companion_instance_10 = this;
    this.w2a_1 = Companion_getInstance_10().z2h(0, 0, 0, 0);
    this.x2a_1 = Companion_getInstance_10().a2i(-Infinity, -Infinity, Infinity, Infinity);
    this.y2a_1 = Companion_getInstance_10().a2i(NaN, NaN, 0.0, 0.0);
  }
  z2a() {
    return this.y2a_1;
  }
  p2d() {
    return this.w2a_1;
  }
  i2b(p, s) {
    return new Rectangle(p.a2a_1, p.b2a_1, s.f2b_1, s.g2b_1);
  }
  z2h(x, y, width, height) {
    return Companion_getInstance_10().i2b(Vector2D.x2c(x, y), Size2D.h2b(width, height));
  }
  a2i(x, y, width, height) {
    return Companion_getInstance_10().i2b(Vector2D.v2e(x, y), Size2D.b2i(width, height));
  }
  c2i(left, top, right, bottom) {
    return new Rectangle(left, top, right - left, bottom - top);
  }
  d2i(left, top, right, bottom) {
    return this.c2i(left, top, right, bottom);
  }
  e2b(point1, point2) {
    var tmp = Companion_getInstance_10();
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var tmp$ret$0 = Vector2D.k2c(point2.a2a_1 - point1.a2a_1, point2.b2a_1 - point1.b2a_1);
    return tmp.i2b(point1, toSize(tmp$ret$0));
  }
  e2i(a, b) {
    return a.k2a_1 >= b.k2a_1 && a.l2a_1 >= b.l2a_1 && a.k2a_1 + a.m2a_1 <= b.k2a_1 + b.m2a_1 && a.l2a_1 + a.n2a_1 <= b.l2a_1 + b.n2a_1;
  }
}
class Rectangle {
  constructor(x, y, width, height) {
    Companion_getInstance_10();
    this.k2a_1 = x;
    this.l2a_1 = y;
    this.m2a_1 = width;
    this.n2a_1 = height;
    this.o2a_1 = true;
  }
  uz() {
    return this;
  }
  f1() {
    return Size2D.f2i(this.m2a_1, this.n2a_1);
  }
  g2i() {
    return isNaN_0(this.k2a_1);
  }
  p2a() {
    return this.g2i();
  }
  q2a() {
    return !this.p2a();
  }
  h2i(other, epsilon) {
    return isAlmostEquals(this.k2a_1, other.k2a_1, epsilon) && isAlmostEquals(this.l2a_1, other.l2a_1, epsilon) && isAlmostEquals(this.m2a_1, other.m2a_1, epsilon) && isAlmostEquals(this.n2a_1, other.n2a_1, epsilon);
  }
  cz(other, epsilon) {
    return this.h2i(other instanceof Rectangle ? other : THROW_CCE(), epsilon);
  }
  toString() {
    return this.p2a() ? 'null' : 'Rectangle(x=' + get_niceStr(this.k2a_1) + ', y=' + get_niceStr(this.l2a_1) + ', width=' + get_niceStr(this.m2a_1) + ', height=' + get_niceStr(this.n2a_1) + ')';
  }
  i2i(scale) {
    return new Rectangle(this.k2a_1 * scale, this.l2a_1 * scale, this.m2a_1 * scale, this.n2a_1 * scale);
  }
  g2c(that) {
    return this.j2i(that.a2a_1, that.b2a_1);
  }
  j2i(x, y) {
    return x >= this.r2a() && x < this.s2a() && (y >= this.t2a() && y < this.u2a());
  }
  r2a() {
    return this.k2a_1;
  }
  t2a() {
    return this.l2a_1;
  }
  s2a() {
    return this.k2a_1 + this.m2a_1;
  }
  u2a() {
    return this.l2a_1 + this.n2a_1;
  }
  j2b() {
    return Vector2D.k2c(this.r2a(), this.t2a());
  }
  k2i() {
    return Vector2D.k2c(this.s2a(), this.t2a());
  }
  l2i() {
    return Vector2D.k2c(this.r2a(), this.u2a());
  }
  l2b() {
    return Vector2D.k2c(this.s2a(), this.u2a());
  }
  m2i() {
    return (this.s2a() + this.r2a()) * 0.5;
  }
  n2i() {
    return (this.u2a() + this.t2a()) * 0.5;
  }
  o2i() {
    return Vector2D.k2c(this.m2i(), this.n2i());
  }
  p2i(that) {
    return this.q2i(that) && this.r2i(that);
  }
  q2i(that) {
    return that.r2a() <= this.s2a() && that.s2a() >= this.r2a();
  }
  r2i(that) {
    return that.t2a() <= this.u2a() && that.u2a() >= this.t2a();
  }
  s2i(that) {
    var tmp;
    if (this.p2i(that)) {
      // Inline function 'kotlin.math.max' call
      var a = this.r2a();
      var b = that.r2a();
      var tmp_0 = Math.max(a, b);
      // Inline function 'kotlin.math.max' call
      var a_0 = this.t2a();
      var b_0 = that.t2a();
      var tmp_1 = Math.max(a_0, b_0);
      // Inline function 'kotlin.math.min' call
      var a_1 = this.s2a();
      var b_1 = that.s2a();
      var tmp_2 = Math.min(a_1, b_1);
      // Inline function 'kotlin.math.min' call
      var a_2 = this.u2a();
      var b_2 = that.u2a();
      var tmp$ret$3 = Math.min(a_2, b_2);
      tmp = new Rectangle(tmp_0, tmp_1, tmp_2, tmp$ret$3);
    } else {
      tmp = Companion_getInstance_10().z2a();
    }
    return tmp;
  }
  j2() {
    return RectangleInt.x2i(numberToInt(this.k2a_1), numberToInt(this.l2a_1), numberToInt(this.m2a_1), numberToInt(this.n2a_1));
  }
  y2i(border) {
    return Companion_getInstance_10().c2i(this.r2a() - border.g2d_1, this.t2a() - border.d2d_1, this.s2a() + border.e2d_1, this.u2a() + border.f2d_1);
  }
  q2e(delta) {
    return this.z2i(this.k2a_1 + delta.a2a_1, this.l2a_1 + delta.b2a_1);
  }
  a2j(m) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var p = this.j2b();
      if (m.p2a()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.k2c(m.e2e(p.a2a_1, p.b2a_1), m.h2e(p.a2a_1, p.b2a_1));
    }
    var tl = tmp$ret$0;
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var p_0 = this.k2i();
      if (m.p2a()) {
        tmp$ret$1 = p_0;
        break $l$block_0;
      }
      tmp$ret$1 = Vector2D.k2c(m.e2e(p_0.a2a_1, p_0.b2a_1), m.h2e(p_0.a2a_1, p_0.b2a_1));
    }
    var tr = tmp$ret$1;
    var tmp$ret$2;
    $l$block_1: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var p_1 = this.l2i();
      if (m.p2a()) {
        tmp$ret$2 = p_1;
        break $l$block_1;
      }
      tmp$ret$2 = Vector2D.k2c(m.e2e(p_1.a2a_1, p_1.b2a_1), m.h2e(p_1.a2a_1, p_1.b2a_1));
    }
    var bl = tmp$ret$2;
    var tmp$ret$3;
    $l$block_2: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var p_2 = this.l2b();
      if (m.p2a()) {
        tmp$ret$3 = p_2;
        break $l$block_2;
      }
      tmp$ret$3 = Vector2D.k2c(m.e2e(p_2.a2a_1, p_2.b2a_1), m.h2e(p_2.a2a_1, p_2.b2a_1));
    }
    var br = tmp$ret$3;
    var min = Companion_getInstance_15().c2b(tl, tr, bl, br);
    var max = Companion_getInstance_15().d2b(tl, tr, bl, br);
    return Companion_getInstance_10().e2b(min, max);
  }
  b2j() {
    return Companion_getInstance_10().e2b(Companion_getInstance_15().k2b(this.j2b(), this.l2b()), Companion_getInstance_15().m2b(this.j2b(), this.l2b()));
  }
  c2j(x, y, width, height) {
    return new Rectangle(x, y, width, height);
  }
  z2i(x, y, width, height, $super) {
    x = x === VOID ? this.k2a_1 : x;
    y = y === VOID ? this.l2a_1 : y;
    width = width === VOID ? this.m2a_1 : width;
    height = height === VOID ? this.n2a_1 : height;
    return $super === VOID ? this.c2j(x, y, width, height) : $super.c2j.call(this, x, y, width, height);
  }
  hashCode() {
    var result = getNumberHashCode(this.k2a_1);
    result = imul(result, 31) + getNumberHashCode(this.l2a_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.m2a_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.n2a_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Rectangle))
      return false;
    var tmp0_other_with_cast = other instanceof Rectangle ? other : THROW_CCE();
    if (!equals(this.k2a_1, tmp0_other_with_cast.k2a_1))
      return false;
    if (!equals(this.l2a_1, tmp0_other_with_cast.l2a_1))
      return false;
    if (!equals(this.m2a_1, tmp0_other_with_cast.m2a_1))
      return false;
    if (!equals(this.n2a_1, tmp0_other_with_cast.n2a_1))
      return false;
    return true;
  }
}
class Companion_11 {
  e2j(a, b) {
    // Inline function 'kotlin.math.min' call
    var a_0 = a.r2a();
    var b_0 = b.r2a();
    var tmp = Math.min(a_0, b_0);
    // Inline function 'kotlin.math.min' call
    var a_1 = a.t2a();
    var b_1 = b.t2a();
    var tmp_0 = Math.min(a_1, b_1);
    // Inline function 'kotlin.math.max' call
    var a_2 = a.s2a();
    var b_2 = b.s2a();
    var tmp_1 = Math.max(a_2, b_2);
    // Inline function 'kotlin.math.max' call
    var a_3 = a.u2a();
    var b_3 = b.u2a();
    var tmp$ret$3 = Math.max(a_3, b_3);
    return this.d2i(tmp, tmp_0, tmp_1, tmp$ret$3);
  }
  f2j(topLeft, bottomRight) {
    var size = bottomRight.i2j(topLeft);
    return RectangleInt.x2i(topLeft.g2j_1, topLeft.h2j_1, size.g2j_1, size.h2j_1);
  }
  d2i(left, top, right, bottom) {
    return this.f2j(Vector2I.j2j(left, top), Vector2I.j2j(right, bottom));
  }
}
class RectangleInt {
  static x2i(x, y, width, height) {
    var $this = createThis(this);
    $this.t2i_1 = x;
    $this.u2i_1 = y;
    $this.v2i_1 = width;
    $this.w2i_1 = height;
    return $this;
  }
  static k2j() {
    return this.x2i(0, 0, 0, 0);
  }
  l2j() {
    return imul(this.v2i_1, this.w2i_1);
  }
  r2a() {
    return this.t2i_1;
  }
  t2a() {
    return this.u2i_1;
  }
  s2a() {
    return this.t2i_1 + this.v2i_1 | 0;
  }
  u2a() {
    return this.u2i_1 + this.w2i_1 | 0;
  }
  m2j(left, top, right, bottom, clamped) {
    var left_0 = !clamped ? left : coerceIn(left, 0, this.v2i_1);
    var right_0 = !clamped ? right : coerceIn(right, 0, this.v2i_1);
    var top_0 = !clamped ? top : coerceIn(top, 0, this.w2i_1);
    var bottom_0 = !clamped ? bottom : coerceIn(bottom, 0, this.w2i_1);
    return Companion_instance_11.d2i(this.t2i_1 + left_0 | 0, this.u2i_1 + top_0 | 0, this.t2i_1 + right_0 | 0, this.u2i_1 + bottom_0 | 0);
  }
  toString() {
    return 'Rectangle(x=' + this.t2i_1 + ', y=' + this.u2i_1 + ', width=' + this.v2i_1 + ', height=' + this.w2i_1 + ')';
  }
  n2j() {
    return Companion_getInstance_10().z2h(this.t2i_1, this.u2i_1, this.v2i_1, this.w2i_1);
  }
  y2i(border) {
    return Companion_instance_11.d2i(this.r2a() - border.g2d_1 | 0, this.t2a() - border.d2d_1 | 0, this.s2a() + border.e2d_1 | 0, this.u2a() + border.f2d_1 | 0);
  }
  hashCode() {
    var result = this.t2i_1;
    result = imul(result, 31) + this.u2i_1 | 0;
    result = imul(result, 31) + this.v2i_1 | 0;
    result = imul(result, 31) + this.w2i_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RectangleInt))
      return false;
    var tmp0_other_with_cast = other instanceof RectangleInt ? other : THROW_CCE();
    if (!(this.t2i_1 === tmp0_other_with_cast.t2i_1))
      return false;
    if (!(this.u2i_1 === tmp0_other_with_cast.u2i_1))
      return false;
    if (!(this.v2i_1 === tmp0_other_with_cast.v2i_1))
      return false;
    if (!(this.w2i_1 === tmp0_other_with_cast.w2i_1))
      return false;
    return true;
  }
}
class Companion_12 {
  constructor() {
    Companion_instance_12 = this;
    this.o2j_1 = Scale.p2j(1.0, 1.0);
  }
}
class Scale {
  static v2h(scaleX, scaleY) {
    Companion_getInstance_12();
    var $this = createThis(this);
    $this.t2h_1 = scaleX;
    $this.u2h_1 = scaleY;
    return $this;
  }
  x2f() {
    return this.t2h_1 * 0.5 + this.u2h_1 * 0.5;
  }
  static q2j() {
    Companion_getInstance_12();
    return this.p2j(1.0, 1.0);
  }
  static r2j(scale) {
    Companion_getInstance_12();
    return this.v2h(scale, scale);
  }
  static s2j(scale) {
    Companion_getInstance_12();
    return this.r2j(scale);
  }
  static p2j(scaleX, scaleY) {
    Companion_getInstance_12();
    return this.v2h(scaleX, scaleY);
  }
  static t2j(scaleX, scaleY) {
    Companion_getInstance_12();
    return this.v2h(scaleX, scaleY);
  }
  toString() {
    return 'Scale(scaleX=' + this.t2h_1 + ', scaleY=' + this.u2h_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.t2h_1);
    result = imul(result, 31) + getNumberHashCode(this.u2h_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Scale))
      return false;
    var tmp0_other_with_cast = other instanceof Scale ? other : THROW_CCE();
    if (!equals(this.t2h_1, tmp0_other_with_cast.t2h_1))
      return false;
    if (!equals(this.u2h_1, tmp0_other_with_cast.u2h_1))
      return false;
    return true;
  }
}
class Companion_13 {
  constructor() {
    Companion_instance_13 = this;
    var tmp = this;
    tmp.x2j_1 = new ScaleMode('COVER', ScaleMode$Companion$COVER$lambda);
    var tmp_0 = this;
    tmp_0.y2j_1 = new ScaleMode('SHOW_ALL', ScaleMode$Companion$SHOW_ALL$lambda);
    var tmp_1 = this;
    tmp_1.z2j_1 = new ScaleMode('EXACT', ScaleMode$Companion$EXACT$lambda);
    var tmp_2 = this;
    tmp_2.a2k_1 = new ScaleMode('NO_SCALE', ScaleMode$Companion$NO_SCALE$lambda);
  }
  b2k() {
    return this.z2j_1;
  }
}
class ScaleMode {
  constructor(name, transform) {
    Companion_getInstance_13();
    name = name === VOID ? null : name;
    this.c2k_1 = name;
    this.d2k_1 = transform;
  }
  toString() {
    return 'ScaleMode(' + this.c2k_1 + ')';
  }
  e2k(item, container) {
    return toInt(this.d2k_1(toFloat(item), toFloat(container)));
  }
}
class Companion_14 {
  constructor() {
    Companion_instance_14 = this;
    this.f2k_1 = Size2D.f2i(0.0, 0.0);
  }
}
class Size2D {
  static f2i(width, height) {
    Companion_getInstance_14();
    var $this = createThis(this);
    $this.f2b_1 = width;
    $this.g2b_1 = height;
    return $this;
  }
  static g2k() {
    Companion_getInstance_14();
    return this.f2i(0.0, 0.0);
  }
  static b2i(width, height) {
    Companion_getInstance_14();
    return this.f2i(width, height);
  }
  static h2b(width, height) {
    Companion_getInstance_14();
    return this.f2i(width, height);
  }
  h2k(scale) {
    return Size2D.f2i(this.f2b_1 * scale.t2h_1, this.g2b_1 * scale.u2h_1);
  }
  i2k(s) {
    return Size2D.f2i(this.f2b_1 * s, this.g2b_1 * s);
  }
  i2i(s) {
    return this.i2k(s);
  }
  u2j(other) {
    return Scale.v2h(this.f2b_1 / other.f2b_1, this.g2b_1 / other.g2b_1);
  }
  toString() {
    return 'Size(width=' + get_niceStr(this.f2b_1) + ', height=' + get_niceStr(this.g2b_1) + ')';
  }
  nl() {
    return this.f2b_1;
  }
  ol() {
    return this.g2b_1;
  }
  j2k(width, height) {
    return Size2D.f2i(width, height);
  }
  k2k(width, height, $super) {
    width = width === VOID ? this.f2b_1 : width;
    height = height === VOID ? this.g2b_1 : height;
    return $super === VOID ? this.j2k(width, height) : $super.j2k.call(this, width, height);
  }
  hashCode() {
    var result = getNumberHashCode(this.f2b_1);
    result = imul(result, 31) + getNumberHashCode(this.g2b_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Size2D))
      return false;
    var tmp0_other_with_cast = other instanceof Size2D ? other : THROW_CCE();
    if (!equals(this.f2b_1, tmp0_other_with_cast.f2b_1))
      return false;
    if (!equals(this.g2b_1, tmp0_other_with_cast.g2b_1))
      return false;
    return true;
  }
}
class SizeInt {
  static n2k(width, height) {
    var $this = createThis(this);
    $this.l2k_1 = width;
    $this.m2k_1 = height;
    return $this;
  }
  static o2k() {
    return this.n2k(0, 0);
  }
  toString() {
    return '' + this.l2k_1 + 'x' + this.m2k_1;
  }
  hashCode() {
    var result = this.l2k_1;
    result = imul(result, 31) + this.m2k_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SizeInt))
      return false;
    var tmp0_other_with_cast = other instanceof SizeInt ? other : THROW_CCE();
    if (!(this.l2k_1 === tmp0_other_with_cast.l2k_1))
      return false;
    if (!(this.m2k_1 === tmp0_other_with_cast.m2k_1))
      return false;
    return true;
  }
}
class Companion_15 {
  constructor() {
    Companion_instance_15 = this;
    this.c2a_1 = Vector2D.k2c(0.0, 0.0);
    this.d2a_1 = Vector2D.k2c(NaN, NaN);
    this.e2a_1 = Vector2D.k2c(-1.0, 0.0);
    this.f2a_1 = Vector2D.k2c(+1.0, 0.0);
    this.g2a_1 = Vector2D.k2c(0.0, +1.0);
    this.h2a_1 = Vector2D.k2c(0.0, -1.0);
    this.i2a_1 = Vector2D.k2c(0.0, -1.0);
    this.j2a_1 = Vector2D.k2c(0.0, +1.0);
  }
  p2k(a, b, up) {
    // Inline function 'korlibs.math.geom.Companion.between' call
    // Inline function 'korlibs.math.geom.Companion.between' call
    Companion_getInstance_0();
    var x0 = a.a2a_1;
    var y0 = a.b2a_1;
    var x1 = b.a2a_1;
    var y1 = b.b2a_1;
    return Angle_between(x0, y0, x1, y1, up);
  }
  q2k(a, b, up, $super) {
    up = up === VOID ? this.g2a_1 : up;
    return $super === VOID ? this.p2k(a, b, up) : $super.p2k.call(this, a, b, up).p29_1;
  }
  d2j(x1, y1, x2, y2) {
    // Inline function 'kotlin.math.hypot' call
    var x = x1 - x2;
    var y = y1 - y2;
    return hypot(x, y);
  }
  r2k(x1, y1, x2, y2) {
    // Inline function 'kotlin.math.hypot' call
    var x = x1 - x2;
    var y = y1 - y2;
    return hypot(x, y);
  }
  s2k(x1, y1, x2, y2) {
    // Inline function 'kotlin.math.hypot' call
    var x = x1 - x2;
    var y = y1 - y2;
    return hypot(x, y);
  }
  t2k(a, b) {
    return this.d2j(a.a2a_1, a.b2a_1, b.a2a_1, b.b2a_1);
  }
  s2b(a, b) {
    return this.u2k(a.a2a_1, a.b2a_1, b.a2a_1, b.b2a_1);
  }
  u2k(x1, y1, x2, y2) {
    return square(this, x1 - x2) + square(this, y1 - y2);
  }
  v2k(ax, ay, bx, by) {
    return ax * by - bx * ay;
  }
  w2k(p1, p2) {
    return this.v2k(p1.a2a_1, p1.b2a_1, p2.a2a_1, p2.b2a_1);
  }
  k2b(p1, p2) {
    // Inline function 'kotlin.math.min' call
    var a = p1.a2a_1;
    var b = p2.a2a_1;
    var tmp = Math.min(a, b);
    // Inline function 'kotlin.math.min' call
    var a_0 = p1.b2a_1;
    var b_0 = p2.b2a_1;
    var tmp$ret$1 = Math.min(a_0, b_0);
    return Vector2D.k2c(tmp, tmp$ret$1);
  }
  c2b(p1, p2, p3, p4) {
    return Vector2D.k2c(minOf(p1.a2a_1, new Float64Array([p2.a2a_1, p3.a2a_1, p4.a2a_1])), minOf(p1.b2a_1, new Float64Array([p2.b2a_1, p3.b2a_1, p4.b2a_1])));
  }
  m2b(p1, p2) {
    // Inline function 'kotlin.math.max' call
    var a = p1.a2a_1;
    var b = p2.a2a_1;
    var tmp = Math.max(a, b);
    // Inline function 'kotlin.math.max' call
    var a_0 = p1.b2a_1;
    var b_0 = p2.b2a_1;
    var tmp$ret$1 = Math.max(a_0, b_0);
    return Vector2D.k2c(tmp, tmp$ret$1);
  }
  d2b(p1, p2, p3, p4) {
    return Vector2D.k2c(maxOf(p1.a2a_1, new Float64Array([p2.a2a_1, p3.a2a_1, p4.a2a_1])), maxOf(p1.b2a_1, new Float64Array([p2.b2a_1, p3.b2a_1, p4.b2a_1])));
  }
}
class Vector2D {
  static k2c(x, y) {
    Companion_getInstance_15();
    var $this = createThis(this);
    $this.a2a_1 = x;
    $this.b2a_1 = y;
    return $this;
  }
  static v2e(x, y) {
    Companion_getInstance_15();
    return this.k2c(x, y);
  }
  static x2c(x, y) {
    Companion_getInstance_15();
    return this.k2c(x, y);
  }
  static v2c() {
    Companion_getInstance_15();
    return this.k2c(0.0, 0.0);
  }
  w2j() {
    // Inline function 'kotlin.math.min' call
    var a = this.a2a_1;
    var b = this.b2a_1;
    return Math.min(a, b);
  }
  v2j() {
    // Inline function 'kotlin.math.max' call
    var a = this.a2a_1;
    var b = this.b2a_1;
    return Math.max(a, b);
  }
  x2k(x, y) {
    // Inline function 'kotlin.math.hypot' call
    var x_0 = x - this.a2a_1;
    var y_0 = y - this.b2a_1;
    return hypot(x_0, y_0);
  }
  y2k(that) {
    return this.x2k(that.a2a_1, that.b2a_1);
  }
  a() {
    // Inline function 'kotlin.math.hypot' call
    var x = this.a2a_1;
    var y = this.b2a_1;
    return hypot(x, y);
  }
  z2k() {
    var x = this.a2a_1;
    var y = this.b2a_1;
    return x * x + y * y;
  }
  a2l() {
    // Inline function 'kotlin.math.hypot' call
    var x = this.a2a_1;
    var y = this.b2a_1;
    return hypot(x, y);
  }
  b2l() {
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var scale = 1.0 / this.a2l();
    return Vector2D.k2c(this.a2a_1 * scale, this.b2a_1 * scale);
  }
  c2l() {
    return Vector2D.k2c(-this.b2a_1, this.a2a_1);
  }
  d2l(other, epsilon) {
    return isAlmostEquals(this.a2a_1, other.a2a_1, epsilon) && isAlmostEquals(this.b2a_1, other.b2a_1, epsilon);
  }
  cz(other, epsilon) {
    return this.d2l(other instanceof Vector2D ? other : THROW_CCE(), epsilon);
  }
  e2l() {
    return '(' + get_niceStr(this.a2a_1) + ', ' + get_niceStr(this.b2a_1) + ')';
  }
  toString() {
    return this.e2l();
  }
  nl() {
    return this.a2a_1;
  }
  ol() {
    return this.b2a_1;
  }
  hashCode() {
    var result = getNumberHashCode(this.a2a_1);
    result = imul(result, 31) + getNumberHashCode(this.b2a_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Vector2D))
      return false;
    var tmp0_other_with_cast = other instanceof Vector2D ? other : THROW_CCE();
    if (!equals(this.a2a_1, tmp0_other_with_cast.a2a_1))
      return false;
    if (!equals(this.b2a_1, tmp0_other_with_cast.b2a_1))
      return false;
    return true;
  }
}
class Companion_16 {
  constructor() {
    Companion_instance_16 = this;
    this.f2l_1 = new Vector4F(0.0, 0.0, 0.0, 0.0);
    this.g2l_1 = new Vector4F(1.0, 1.0, 1.0, 1.0);
  }
}
class Vector4F {
  constructor(x, y, z, w) {
    Companion_getInstance_16();
    this.h2l_1 = x;
    this.i2l_1 = y;
    this.j2l_1 = z;
    this.k2l_1 = w;
  }
  toString() {
    return 'Vector4(' + get_niceStr_0(this.h2l_1) + ', ' + get_niceStr_0(this.i2l_1) + ', ' + get_niceStr_0(this.j2l_1) + ', ' + get_niceStr_0(this.k2l_1) + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.h2l_1);
    result = imul(result, 31) + getNumberHashCode(this.i2l_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.j2l_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.k2l_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Vector4F))
      return false;
    var tmp0_other_with_cast = other instanceof Vector4F ? other : THROW_CCE();
    if (!equals(this.h2l_1, tmp0_other_with_cast.h2l_1))
      return false;
    if (!equals(this.i2l_1, tmp0_other_with_cast.i2l_1))
      return false;
    if (!equals(this.j2l_1, tmp0_other_with_cast.j2l_1))
      return false;
    if (!equals(this.k2l_1, tmp0_other_with_cast.k2l_1))
      return false;
    return true;
  }
}
class Companion_17 {
  constructor() {
    Companion_instance_17 = this;
    this.l2l_1 = new Vector3F(NaN, NaN, NaN);
    this.m2l_1 = new Vector3F(0.0, 0.0, 0.0);
    this.n2l_1 = new Vector3F(1.0, 1.0, 1.0);
    this.o2l_1 = new Vector3F(0.0, 0.0, 1.0);
    this.p2l_1 = new Vector3F(0.0, 0.0, -1.0);
    this.q2l_1 = new Vector3F(-1.0, 0.0, 0.0);
    this.r2l_1 = new Vector3F(1.0, 0.0, 0.0);
    this.s2l_1 = new Vector3F(0.0, 1.0, 0.0);
    this.t2l_1 = new Vector3F(0.0, -1.0, 0.0);
  }
}
class Vector3F {
  constructor(x, y, z) {
    Companion_getInstance_17();
    this.u2l_1 = x;
    this.v2l_1 = y;
    this.w2l_1 = z;
  }
  x2l(other) {
    var dx = this.u2l_1 - other.u2l_1;
    var dy = this.v2l_1 - other.v2l_1;
    var dz = this.w2l_1 - other.w2l_1;
    // Inline function 'kotlin.math.sqrt' call
    var x = dx * dx + dy * dy + dz * dz;
    return Math.sqrt(x);
  }
  toString() {
    return 'Vector3(' + get_niceStr_0(this.u2l_1) + ', ' + get_niceStr_0(this.v2l_1) + ', ' + get_niceStr_0(this.w2l_1) + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.u2l_1);
    result = imul(result, 31) + getNumberHashCode(this.v2l_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.w2l_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Vector3F))
      return false;
    var tmp0_other_with_cast = other instanceof Vector3F ? other : THROW_CCE();
    if (!equals(this.u2l_1, tmp0_other_with_cast.u2l_1))
      return false;
    if (!equals(this.v2l_1, tmp0_other_with_cast.v2l_1))
      return false;
    if (!equals(this.w2l_1, tmp0_other_with_cast.w2l_1))
      return false;
    return true;
  }
}
class Companion_18 {
  constructor() {
    Companion_instance_18 = this;
    this.y2l_1 = Vector2I.j2j(0, 0);
  }
}
class Vector2I {
  static j2j(x, y) {
    Companion_getInstance_18();
    var $this = createThis(this);
    $this.g2j_1 = x;
    $this.h2j_1 = y;
    return $this;
  }
  static z2l() {
    Companion_getInstance_18();
    return this.j2j(0, 0);
  }
  i2j(that) {
    return Vector2I.j2j(this.g2j_1 - that.g2j_1 | 0, this.h2j_1 - that.h2j_1 | 0);
  }
  toString() {
    return '(' + this.g2j_1 + ', ' + this.h2j_1 + ')';
  }
  hashCode() {
    var result = this.g2j_1;
    result = imul(result, 31) + this.h2j_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Vector2I))
      return false;
    var tmp0_other_with_cast = other instanceof Vector2I ? other : THROW_CCE();
    if (!(this.g2j_1 === tmp0_other_with_cast.g2j_1))
      return false;
    if (!(this.h2j_1 === tmp0_other_with_cast.h2j_1))
      return false;
    return true;
  }
}
//endregion
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new Companion();
  return Companion_instance;
}
function _Angle___init__impl__g23q1m(radians) {
  return radians;
}
function _Angle___get_radians__impl__n00yt5($this) {
  return $this;
}
function _Angle___get_ratio__impl__ap3on4($this) {
  // Inline function 'korlibs.math.geom.Companion.radiansToRatio' call
  Companion_getInstance_0();
  var radians = _Angle___get_radians__impl__n00yt5($this);
  return _Ratio___init__impl__9mwvn2(radians / 6.283185307179586);
}
function _Angle___get_degrees__impl__qg56vw($this) {
  // Inline function 'korlibs.math.geom.Companion.radiansToDegrees' call
  Companion_getInstance_0();
  return _Angle___get_radians__impl__n00yt5($this) * 57.29577951308232;
}
function _Angle___get_cosine__impl__vprvmu($this) {
  // Inline function 'kotlin.math.cos' call
  var x = _Angle___get_radians__impl__n00yt5($this);
  return Math.cos(x);
}
function _Angle___get_sine__impl__15nmyi($this) {
  // Inline function 'kotlin.math.sin' call
  var x = _Angle___get_radians__impl__n00yt5($this);
  return Math.sin(x);
}
function _Angle___get_tangent__impl__vushdy($this) {
  // Inline function 'kotlin.math.tan' call
  var x = _Angle___get_radians__impl__n00yt5($this);
  return Math.tan(x);
}
function Angle__cosine_impl_bgvzun($this, up) {
  return _Angle___get_cosine__impl__vprvmu(adjustFromUp($this, up));
}
function Angle__sine_impl_3l11xv($this, up) {
  return _Angle___get_sine__impl__15nmyi(adjustFromUp($this, up));
}
function _Angle___get_absoluteValue__impl__4qoakv($this) {
  // Inline function 'kotlin.math.absoluteValue' call
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var this_0 = _Angle___get_radians__impl__n00yt5($this);
  var tmp$ret$1 = Math.abs(this_0);
  return _Angle___init__impl__g23q1m(tmp$ret$1);
}
function Angle__div_impl_ut2btd($this, scale) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$0 = _Angle___get_radians__impl__n00yt5($this);
  return _Angle___init__impl__g23q1m(tmp$ret$0 / scale);
}
function Angle__times_impl_v3s9y2($this, scale) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$0 = _Angle___get_radians__impl__n00yt5($this);
  return _Angle___init__impl__g23q1m(tmp$ret$0 * scale);
}
function Angle__umod_impl_4wilf7($this, angle) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp = _Angle___get_radians__impl__n00yt5($this);
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$1 = _Angle___get_radians__impl__n00yt5(angle);
  return _Angle___init__impl__g23q1m(umod(tmp, tmp$ret$1));
}
function Angle__div_impl_ut2btd_0($this, other) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp = _Angle___get_radians__impl__n00yt5($this);
  // Inline function 'korlibs.math.geom.Angle.internal' call
  return tmp / _Angle___get_radians__impl__n00yt5(other);
}
function Angle__plus_impl_26v37k($this, other) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp = _Angle___get_radians__impl__n00yt5($this);
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$1 = _Angle___get_radians__impl__n00yt5(other);
  return _Angle___init__impl__g23q1m(tmp + tmp$ret$1);
}
function Angle__minus_impl_xeau7k($this, other) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp = _Angle___get_radians__impl__n00yt5($this);
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$1 = _Angle___get_radians__impl__n00yt5(other);
  return _Angle___init__impl__g23q1m(tmp - tmp$ret$1);
}
function Angle__unaryMinus_impl_7901fr($this) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$0 = _Angle___get_radians__impl__n00yt5($this);
  return _Angle___init__impl__g23q1m(-tmp$ret$0);
}
function Angle__unaryPlus_impl_eyi5pl($this) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$0 = _Angle___get_radians__impl__n00yt5($this);
  return _Angle___init__impl__g23q1m(+tmp$ret$0);
}
function Angle__isAlmostEquals_impl_201sgt($this, other, epsilon) {
  return isAlmostEquals(_Angle___get_radians__impl__n00yt5($this), _Angle___get_radians__impl__n00yt5(other), epsilon);
}
function Angle__isAlmostEquals_impl_201sgt_0($this, other, epsilon) {
  return Angle__isAlmostEquals_impl_201sgt($this.p29_1, other instanceof Angle ? other.p29_1 : THROW_CCE(), epsilon);
}
function _Angle___get_normalized__impl__9s30ys($this) {
  // Inline function 'korlibs.math.geom.Companion.fromRatio' call
  Companion_getInstance_0();
  var ratio = umod(Ratio__toDouble_impl_o7epze(_Angle___get_ratio__impl__ap3on4($this)), 1.0);
  // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
  var ratio_0 = toRatio(ratio);
  var tmp$ret$0 = Ratio__times_impl_ucdh7y(ratio_0, 6.283185307179586);
  return _Angle___init__impl__g23q1m(tmp$ret$0);
}
function Angle__compareTo_impl_a0hfds($this, other) {
  return Ratio__compareTo_impl_z2ienc(_Angle___get_ratio__impl__ap3on4($this), _Angle___get_ratio__impl__ap3on4(other));
}
function Angle__compareTo_impl_a0hfds_0($this, other) {
  return Angle__compareTo_impl_a0hfds($this.p29_1, other instanceof Angle ? other.p29_1 : THROW_CCE());
}
function Angle__toString_impl_786qky($this) {
  return get_niceStr(roundDecimalPlaces(_Angle___get_degrees__impl__qg56vw($this), 2)) + '.degrees';
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new Companion_0();
  return Companion_instance_0;
}
function Angle__hashCode_impl_szcndt($this) {
  return getNumberHashCode($this);
}
function Angle__equals_impl_zcf5mt($this, other) {
  if (!(other instanceof Angle))
    return false;
  var tmp0_other_with_cast = other instanceof Angle ? other.p29_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function get_degrees(_this__u8e3s4) {
  // Inline function 'korlibs.math.geom.Companion.fromDegrees' call
  // Inline function 'korlibs.math.geom.Companion.degreesToRadians' call
  Companion_getInstance_0();
  var tmp$ret$0 = _this__u8e3s4 * 0.017453292519943295;
  return _Angle___init__impl__g23q1m(tmp$ret$0);
}
function get_radians(_this__u8e3s4) {
  // Inline function 'korlibs.math.geom.Companion.fromRadians' call
  Companion_getInstance_0();
  return _Angle___init__impl__g23q1m(_this__u8e3s4);
}
function interpolateAngleDenormalized(_this__u8e3s4, l, r) {
  return interpolateAngle(_this__u8e3s4, l, r, false);
}
function get_radians_0(_this__u8e3s4) {
  // Inline function 'korlibs.math.geom.Companion.fromRadians' call
  Companion_getInstance_0();
  return _Angle___init__impl__g23q1m(_this__u8e3s4);
}
function adjustFromUp(_this__u8e3s4, up) {
  Companion_instance_9.z29(up);
  return up.b2a_1 > 0 ? _this__u8e3s4 : Angle__unaryMinus_impl_7901fr(_this__u8e3s4);
}
function Angle_between(x0, y0, x1, y1, up) {
  up = up === VOID ? Companion_getInstance_15().g2a_1 : up;
  // Inline function 'korlibs.math.geom.Companion.atan2' call
  Companion_getInstance_0();
  var x = y1 - y0;
  var y = x1 - x0;
  var up_0 = Companion_getInstance_15().g2a_1;
  // Inline function 'korlibs.math.geom.Companion.fromRadians' call
  // Inline function 'kotlin.math.atan2' call
  var radians = Math.atan2(x, y);
  var tmp$ret$1 = _Angle___init__impl__g23q1m(radians);
  var angle = adjustFromUp(tmp$ret$1, up_0);
  return adjustFromUp(Angle__compareTo_impl_a0hfds(angle, Companion_getInstance_0().r29_1) < 0 ? Angle__plus_impl_26v37k(angle, Companion_getInstance_0().v29_1) : angle, up);
}
function interpolateAngle(_this__u8e3s4, l, r, minimizeAngle) {
  return _interpolateAngleAny(_this__u8e3s4, l, r, minimizeAngle);
}
function _interpolateAngleAny(ratio, l, r, minimizeAngle) {
  minimizeAngle = minimizeAngle === VOID ? true : minimizeAngle;
  if (!minimizeAngle) {
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    Companion_getInstance_0();
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    var ratio_0 = interpolate(ratio, _Angle___get_ratio__impl__ap3on4(l), _Angle___get_ratio__impl__ap3on4(r));
    var tmp$ret$0 = Ratio__times_impl_ucdh7y(ratio_0, 6.283185307179586);
    return _Angle___init__impl__g23q1m(tmp$ret$0);
  }
  var ln = _Angle___get_normalized__impl__9s30ys(l);
  var rn = _Angle___get_normalized__impl__9s30ys(r);
  var tmp;
  if (Angle__compareTo_impl_a0hfds(_Angle___get_absoluteValue__impl__4qoakv(Angle__minus_impl_xeau7k(rn, ln)), Companion_getInstance_0().t29_1) <= 0) {
    // Inline function 'korlibs.math.geom.Companion.fromRadians' call
    Companion_getInstance_0();
    var radians = interpolate_0(ratio, _Angle___get_radians__impl__n00yt5(ln), _Angle___get_radians__impl__n00yt5(rn));
    tmp = _Angle___init__impl__g23q1m(radians);
  } else if (Angle__compareTo_impl_a0hfds(ln, rn) < 0) {
    // Inline function 'korlibs.math.geom.Companion.fromRadians' call
    Companion_getInstance_0();
    var radians_0 = interpolate_0(ratio, _Angle___get_radians__impl__n00yt5(Angle__plus_impl_26v37k(ln, Companion_getInstance_0().v29_1)), _Angle___get_radians__impl__n00yt5(rn));
    var tmp$ret$3 = _Angle___init__impl__g23q1m(radians_0);
    tmp = _Angle___get_normalized__impl__9s30ys(tmp$ret$3);
  } else {
    // Inline function 'korlibs.math.geom.Companion.fromRadians' call
    Companion_getInstance_0();
    var radians_1 = interpolate_0(ratio, _Angle___get_radians__impl__n00yt5(ln), _Angle___get_radians__impl__n00yt5(Angle__plus_impl_26v37k(rn, Companion_getInstance_0().v29_1)));
    var tmp$ret$4 = _Angle___init__impl__g23q1m(radians_1);
    tmp = _Angle___get_normalized__impl__9s30ys(tmp$ret$4);
  }
  return tmp;
}
function _BoundsBuilder___init__impl__g6dprh(bounds) {
  return bounds;
}
function _BoundsBuilder___get_bounds__impl__s1l1gx($this) {
  return $this;
}
function _BoundsBuilder___get_isEmpty__impl__e9t785($this) {
  return _BoundsBuilder___get_bounds__impl__s1l1gx($this).p2a();
}
function _BoundsBuilder___get_isNotEmpty__impl__w6rbsy($this) {
  return _BoundsBuilder___get_bounds__impl__s1l1gx($this).q2a();
}
function _BoundsBuilder___get_xmin__impl__o2sib0($this) {
  // Inline function 'kotlin.math.min' call
  var a = _BoundsBuilder___get_bounds__impl__s1l1gx($this).r2a();
  var b = _BoundsBuilder___get_bounds__impl__s1l1gx($this).s2a();
  return Math.min(a, b);
}
function _BoundsBuilder___get_xmax__impl__gsz0km($this) {
  // Inline function 'kotlin.math.max' call
  var a = _BoundsBuilder___get_bounds__impl__s1l1gx($this).r2a();
  var b = _BoundsBuilder___get_bounds__impl__s1l1gx($this).s2a();
  return Math.max(a, b);
}
function _BoundsBuilder___get_ymin__impl__5n2e8j($this) {
  // Inline function 'kotlin.math.min' call
  var a = _BoundsBuilder___get_bounds__impl__s1l1gx($this).t2a();
  var b = _BoundsBuilder___get_bounds__impl__s1l1gx($this).u2a();
  return Math.min(a, b);
}
function _BoundsBuilder___get_ymax__impl__oia4uz($this) {
  // Inline function 'kotlin.math.max' call
  var a = _BoundsBuilder___get_bounds__impl__s1l1gx($this).t2a();
  var b = _BoundsBuilder___get_bounds__impl__s1l1gx($this).u2a();
  return Math.max(a, b);
}
function BoundsBuilder__xminOr_impl_k3l1m2($this, default_0) {
  return _BoundsBuilder___get_hasPoints__impl__6mwi9x($this) ? _BoundsBuilder___get_xmin__impl__o2sib0($this) : default_0;
}
function _BoundsBuilder___get_hasPoints__impl__6mwi9x($this) {
  return _BoundsBuilder___get_isNotEmpty__impl__w6rbsy($this);
}
var Companion_instance_1;
function Companion_getInstance_1() {
  if (Companion_instance_1 === VOID)
    new Companion_1();
  return Companion_instance_1;
}
function BoundsBuilder__plus_impl_cz7f7x($this, p) {
  if (_BoundsBuilder___get_bounds__impl__s1l1gx($this).p2a())
    return _BoundsBuilder___init__impl__g6dprh(Companion_getInstance_10().i2b(p, Size2D.h2b(0, 0)));
  return _BoundsBuilder___init__impl__g6dprh(Companion_getInstance_10().e2b(Companion_getInstance_15().k2b(_BoundsBuilder___get_bounds__impl__s1l1gx($this).j2b(), p), Companion_getInstance_15().m2b(_BoundsBuilder___get_bounds__impl__s1l1gx($this).l2b(), p)));
}
function BoundsBuilder__plus_impl_cz7f7x_0($this, rect) {
  if (rect == null)
    return $this;
  if (rect.p2a())
    return $this;
  return BoundsBuilder__plus_impl_cz7f7x(BoundsBuilder__plus_impl_cz7f7x($this, rect.j2b()), rect.l2b());
}
function BoundsBuilder__plus_impl_cz7f7x_1($this, p) {
  var bb = $this;
  var inductionVariable = 0;
  var last = p.f1();
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      bb = BoundsBuilder__plus_impl_cz7f7x(bb, p.e1(n));
    }
     while (inductionVariable < last);
  return bb;
}
function BoundsBuilder__plus_impl_cz7f7x_2($this, rects) {
  var bb = $this;
  var _iterator__ex2g4s = rects.b1();
  while (_iterator__ex2g4s.c1()) {
    var it = _iterator__ex2g4s.d1();
    bb = BoundsBuilder__plus_impl_cz7f7x_0(bb, it);
  }
  return bb;
}
function BoundsBuilder__boundsOrNull_impl_se9lyg($this) {
  return _BoundsBuilder___get_isEmpty__impl__e9t785($this) ? null : _BoundsBuilder___get_bounds__impl__s1l1gx($this);
}
function BoundsBuilder__toString_impl_fmvxh7($this) {
  return 'BoundsBuilder(bounds=' + $this.toString() + ')';
}
function BoundsBuilder__hashCode_impl_649zbo($this) {
  return $this.hashCode();
}
function BoundsBuilder__equals_impl_jngfjs($this, other) {
  if (!(other instanceof BoundsBuilder))
    return false;
  var tmp0_other_with_cast = other instanceof BoundsBuilder ? other.n2b_1 : THROW_CCE();
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
var Companion_instance_2;
function Companion_getInstance_2() {
  return Companion_instance_2;
}
var Companion_instance_3;
function Companion_getInstance_3() {
  return Companion_instance_3;
}
var Companion_instance_4;
function Companion_getInstance_4() {
  if (Companion_instance_4 === VOID)
    new Companion_4();
  return Companion_instance_4;
}
var Companion_instance_5;
function Companion_getInstance_5() {
  if (Companion_instance_5 === VOID)
    new Companion_5();
  return Companion_instance_5;
}
var Companion_instance_6;
function Companion_getInstance_6() {
  if (Companion_instance_6 === VOID)
    new Companion_6();
  return Companion_instance_6;
}
var MatrixType_IDENTITY_instance;
var MatrixType_TRANSLATE_instance;
var MatrixType_SCALE_instance;
var MatrixType_SCALE_TRANSLATE_instance;
var MatrixType_COMPLEX_instance;
var MatrixType_entriesInitialized;
function MatrixType_initEntries() {
  if (MatrixType_entriesInitialized)
    return Unit_instance;
  MatrixType_entriesInitialized = true;
  MatrixType_IDENTITY_instance = new MatrixType('IDENTITY', 0, 1, false, false, false);
  MatrixType_TRANSLATE_instance = new MatrixType('TRANSLATE', 1, 2, false, false, true);
  MatrixType_SCALE_instance = new MatrixType('SCALE', 2, 3, false, true, false);
  MatrixType_SCALE_TRANSLATE_instance = new MatrixType('SCALE_TRANSLATE', 3, 4, false, true, true);
  MatrixType_COMPLEX_instance = new MatrixType('COMPLEX', 4, 5, true, true, true);
}
var Companion_instance_7;
function Companion_getInstance_7() {
  if (Companion_instance_7 === VOID)
    new Companion_7();
  return Companion_instance_7;
}
function MatrixType_IDENTITY_getInstance() {
  MatrixType_initEntries();
  return MatrixType_IDENTITY_instance;
}
function MatrixType_TRANSLATE_getInstance() {
  MatrixType_initEntries();
  return MatrixType_TRANSLATE_instance;
}
function MatrixType_SCALE_getInstance() {
  MatrixType_initEntries();
  return MatrixType_SCALE_instance;
}
function MatrixType_SCALE_TRANSLATE_getInstance() {
  MatrixType_initEntries();
  return MatrixType_SCALE_TRANSLATE_instance;
}
function MatrixType_COMPLEX_getInstance() {
  MatrixType_initEntries();
  return MatrixType_COMPLEX_instance;
}
var Companion_instance_8;
function Companion_getInstance_8() {
  if (Companion_instance_8 === VOID)
    new Companion_8();
  return Companion_instance_8;
}
function ortho(_this__u8e3s4, rect, near, far) {
  near = near === VOID ? 0.0 : near;
  far = far === VOID ? 1.0 : far;
  return Companion_getInstance_8().p2h(rect.r2a(), rect.s2a(), rect.u2a(), rect.t2a(), near, far);
}
function scaled(_this__u8e3s4, scale) {
  return _this__u8e3s4.m2e(scale.t2h_1, scale.u2h_1);
}
function get_scale(_this__u8e3s4) {
  return Scale.v2h(_this__u8e3s4.n2f_1, _this__u8e3s4.o2f_1);
}
var Orientation_CLOCK_WISE_instance;
var Orientation_COUNTER_CLOCK_WISE_instance;
var Orientation_COLLINEAR_instance;
var Companion_instance_9;
function Companion_getInstance_9() {
  return Companion_instance_9;
}
var Orientation_entriesInitialized;
function Orientation_initEntries() {
  if (Orientation_entriesInitialized)
    return Unit_instance;
  Orientation_entriesInitialized = true;
  Orientation_CLOCK_WISE_instance = new Orientation('CLOCK_WISE', 0, 1);
  Orientation_COUNTER_CLOCK_WISE_instance = new Orientation('COUNTER_CLOCK_WISE', 1, -1);
  Orientation_COLLINEAR_instance = new Orientation('COLLINEAR', 2, 0);
}
var Companion_instance_10;
function Companion_getInstance_10() {
  if (Companion_instance_10 === VOID)
    new Companion_10();
  return Companion_instance_10;
}
function outerCircle(_this__u8e3s4) {
  var centerX = _this__u8e3s4.m2i();
  var centerY = _this__u8e3s4.n2i();
  return new Circle(_this__u8e3s4.o2i(), Companion_getInstance_15().d2j(centerX, centerY, _this__u8e3s4.s2a(), _this__u8e3s4.t2a()));
}
var Companion_instance_11;
function Companion_getInstance_11() {
  return Companion_instance_11;
}
var Companion_instance_12;
function Companion_getInstance_12() {
  if (Companion_instance_12 === VOID)
    new Companion_12();
  return Companion_instance_12;
}
function toVector2(_this__u8e3s4) {
  return Vector2D.k2c(_this__u8e3s4.t2h_1, _this__u8e3s4.u2h_1);
}
function ScaleMode$Companion$COVER$lambda(i, c) {
  return i.i2i(toVector2(c.u2j(i)).v2j());
}
function ScaleMode$Companion$SHOW_ALL$lambda(i, c) {
  return i.i2i(toVector2(c.u2j(i)).w2j());
}
function ScaleMode$Companion$EXACT$lambda(i, c) {
  return c;
}
function ScaleMode$Companion$NO_SCALE$lambda(i, c) {
  return i;
}
var Companion_instance_13;
function Companion_getInstance_13() {
  if (Companion_instance_13 === VOID)
    new Companion_13();
  return Companion_instance_13;
}
var Companion_instance_14;
function Companion_getInstance_14() {
  if (Companion_instance_14 === VOID)
    new Companion_14();
  return Companion_instance_14;
}
function toFloat(_this__u8e3s4) {
  return Size2D.b2i(_this__u8e3s4.l2k_1, _this__u8e3s4.m2k_1);
}
function toInt(_this__u8e3s4) {
  return SizeInt.n2k(numberToInt(_this__u8e3s4.f2b_1), numberToInt(_this__u8e3s4.g2b_1));
}
function toSize(_this__u8e3s4) {
  return Size2D.f2i(_this__u8e3s4.a2a_1, _this__u8e3s4.b2a_1);
}
function transformX(_this__u8e3s4, m) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.math.geom.Matrix.transform' call
    if (m.p2a()) {
      tmp$ret$0 = _this__u8e3s4;
      break $l$block;
    }
    tmp$ret$0 = Vector2D.k2c(m.e2e(_this__u8e3s4.a2a_1, _this__u8e3s4.b2a_1), m.h2e(_this__u8e3s4.a2a_1, _this__u8e3s4.b2a_1));
  }
  return tmp$ret$0.a2a_1;
}
function transformY(_this__u8e3s4, m) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.math.geom.Matrix.transform' call
    if (m.p2a()) {
      tmp$ret$0 = _this__u8e3s4;
      break $l$block;
    }
    tmp$ret$0 = Vector2D.k2c(m.e2e(_this__u8e3s4.a2a_1, _this__u8e3s4.b2a_1), m.h2e(_this__u8e3s4.a2a_1, _this__u8e3s4.b2a_1));
  }
  return tmp$ret$0.b2a_1;
}
function square($this, x) {
  return x * x;
}
var Companion_instance_15;
function Companion_getInstance_15() {
  if (Companion_instance_15 === VOID)
    new Companion_15();
  return Companion_instance_15;
}
function toInt_0(_this__u8e3s4) {
  return Vector2I.j2j(numberToInt(_this__u8e3s4.a2a_1), numberToInt(_this__u8e3s4.b2a_1));
}
var Companion_instance_16;
function Companion_getInstance_16() {
  if (Companion_instance_16 === VOID)
    new Companion_16();
  return Companion_instance_16;
}
var Companion_instance_17;
function Companion_getInstance_17() {
  if (Companion_instance_17 === VOID)
    new Companion_17();
  return Companion_instance_17;
}
var Companion_instance_18;
function Companion_getInstance_18() {
  if (Companion_instance_18 === VOID)
    new Companion_18();
  return Companion_instance_18;
}
function interpolate_1(_this__u8e3s4, l, r) {
  return Vector2D.k2c(interpolate_0(_this__u8e3s4, l.a2a_1, r.a2a_1), interpolate_0(_this__u8e3s4, l.b2a_1, r.b2a_1));
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForClass(Anchor2D, 'Anchor2D');
initMetadataForCompanion(Companion_0);
protoOf(Angle).dz = isAlmostEquals$default;
initMetadataForClass(Angle, 'Angle', VOID, VOID, [Comparable, IsAlmostEquals]);
initMetadataForCompanion(Companion_1);
initMetadataForClass(BoundsBuilder, 'BoundsBuilder');
initMetadataForCompanion(Companion_2);
initMetadataForClass(Circle, 'Circle');
initMetadataForClass(IPointList$Sublist$listIterator$1);
initMetadataForClass(Sublist, 'Sublist', VOID, VOID, [KtList]);
initMetadataForCompanion(Companion_3);
initMetadataForInterface(IDoubleVectorList, 'IDoubleVectorList', VOID, VOID, [IsAlmostEquals]);
initMetadataForInterface(IPointList, 'IPointList', VOID, VOID, [IDoubleVectorList, KtList]);
initMetadataForCompanion(Companion_4);
initMetadataForClass(Line2D, 'Line2D', Line2D.u2c);
initMetadataForCompanion(Companion_5);
initMetadataForClass(MarginInt, 'MarginInt');
initMetadataForCompanion(Companion_6);
protoOf(Matrix).dz = isAlmostEquals$default;
initMetadataForClass(Matrix, 'Matrix', VOID, VOID, [IsAlmostEquals]);
initMetadataForClass(MatrixType, 'MatrixType');
initMetadataForCompanion(Companion_7);
protoOf(MatrixTransform).dz = isAlmostEquals$default;
initMetadataForClass(MatrixTransform, 'MatrixTransform', VOID, VOID, [IsAlmostEquals]);
initMetadataForCompanion(Companion_8);
initMetadataForClass(Matrix4, 'Matrix4', Matrix4.u2g);
initMetadataForCompanion(Companion_9);
initMetadataForClass(Orientation, 'Orientation');
initMetadataForCompanion(Companion_10);
protoOf(Rectangle).dz = isAlmostEquals$default;
initMetadataForClass(Rectangle, 'Rectangle', VOID, VOID, [IsAlmostEquals]);
initMetadataForCompanion(Companion_11);
initMetadataForClass(RectangleInt, 'RectangleInt', RectangleInt.k2j);
initMetadataForCompanion(Companion_12);
initMetadataForClass(Scale, 'Scale', Scale.q2j);
initMetadataForCompanion(Companion_13);
initMetadataForClass(ScaleMode, 'ScaleMode');
initMetadataForCompanion(Companion_14);
initMetadataForClass(Size2D, 'Size2D', Size2D.g2k);
initMetadataForClass(SizeInt, 'SizeInt', SizeInt.o2k);
initMetadataForCompanion(Companion_15);
protoOf(Vector2D).dz = isAlmostEquals$default;
initMetadataForClass(Vector2D, 'Vector2D', Vector2D.v2c, VOID, [IsAlmostEquals]);
initMetadataForCompanion(Companion_16);
initMetadataForClass(Vector4F, 'Vector4F');
initMetadataForCompanion(Companion_17);
initMetadataForClass(Vector3F, 'Vector3F');
initMetadataForCompanion(Companion_18);
initMetadataForClass(Vector2I, 'Vector2I', Vector2I.z2l);
//endregion
//region block: init
Companion_instance_2 = new Companion_2();
Companion_instance_3 = new Companion_3();
Companion_instance_9 = new Companion_9();
Companion_instance_11 = new Companion_11();
//endregion
//region block: exports
export {
  MatrixType_IDENTITY_getInstance as MatrixType_IDENTITY_getInstance26n3n49ggvwm4,
  _Angle___init__impl__g23q1m as _Angle___init__impl__g23q1m36yxttgnpy5tv,
  _Angle___get_absoluteValue__impl__4qoakv as _Angle___get_absoluteValue__impl__4qoakv4cdwg294ssle,
  Angle__compareTo_impl_a0hfds as Angle__compareTo_impl_a0hfds24obl4qqhxk1t,
  _Angle___get_cosine__impl__vprvmu as _Angle___get_cosine__impl__vprvmu3ab5uwcliuboq,
  Angle__cosine_impl_bgvzun as Angle__cosine_impl_bgvzun1b2925dagclby,
  _Angle___get_degrees__impl__qg56vw as _Angle___get_degrees__impl__qg56vw2n539uvc01e1n,
  Angle__div_impl_ut2btd as Angle__div_impl_ut2btd1qmy7ftoy1opp,
  Angle__div_impl_ut2btd_0 as Angle__div_impl_ut2btd19ndx9mxcgcss,
  Angle__hashCode_impl_szcndt as Angle__hashCode_impl_szcndtx0rhatnvuhb1,
  Angle__minus_impl_xeau7k as Angle__minus_impl_xeau7ko02ca30grn4a,
  _Angle___get_normalized__impl__9s30ys as _Angle___get_normalized__impl__9s30ys1q15xt9x23bx,
  Angle__plus_impl_26v37k as Angle__plus_impl_26v37karx983dsduoy,
  _Angle___get_radians__impl__n00yt5 as _Angle___get_radians__impl__n00yt518seywpfbf9fr,
  _Angle___get_ratio__impl__ap3on4 as _Angle___get_ratio__impl__ap3on435dv91f5cbp85,
  _Angle___get_sine__impl__15nmyi as _Angle___get_sine__impl__15nmyi39oh4tio4auz1,
  Angle__sine_impl_3l11xv as Angle__sine_impl_3l11xv3pgl8zzgp52i0,
  _Angle___get_tangent__impl__vushdy as _Angle___get_tangent__impl__vushdy2zy6w59e4l7qg,
  Angle__times_impl_v3s9y2 as Angle__times_impl_v3s9y21yznxo5bj1uj7,
  Angle__umod_impl_4wilf7 as Angle__umod_impl_4wilf71vq5gai237g1r,
  Angle__unaryMinus_impl_7901fr as Angle__unaryMinus_impl_7901fruk5m76f5kg06,
  Angle__unaryPlus_impl_eyi5pl as Angle__unaryPlus_impl_eyi5plrfyn5fslhvdp,
  _BoundsBuilder___get_bounds__impl__s1l1gx as _BoundsBuilder___get_bounds__impl__s1l1gx2fs31mzomv5i,
  BoundsBuilder__boundsOrNull_impl_se9lyg as BoundsBuilder__boundsOrNull_impl_se9lyg1z0iqowyff423,
  BoundsBuilder__hashCode_impl_649zbo as BoundsBuilder__hashCode_impl_649zbo2cbmgnd4y2see,
  BoundsBuilder__plus_impl_cz7f7x as BoundsBuilder__plus_impl_cz7f7xocbq7jeozma3,
  BoundsBuilder__plus_impl_cz7f7x_2 as BoundsBuilder__plus_impl_cz7f7xqnc8b6uzo82y,
  BoundsBuilder__plus_impl_cz7f7x_1 as BoundsBuilder__plus_impl_cz7f7xiu6sbkxslhhl,
  BoundsBuilder__plus_impl_cz7f7x_0 as BoundsBuilder__plus_impl_cz7f7xm06pofb9kabm,
  BoundsBuilder__toString_impl_fmvxh7 as BoundsBuilder__toString_impl_fmvxh7qh65bafrb2p,
  _BoundsBuilder___get_xmax__impl__gsz0km as _BoundsBuilder___get_xmax__impl__gsz0km31n4zf6la54qa,
  _BoundsBuilder___get_xmin__impl__o2sib0 as _BoundsBuilder___get_xmin__impl__o2sib0fqg01yornfcx,
  BoundsBuilder__xminOr_impl_k3l1m2 as BoundsBuilder__xminOr_impl_k3l1m233j5xey4uzzri,
  _BoundsBuilder___get_ymax__impl__oia4uz as _BoundsBuilder___get_ymax__impl__oia4uz2kb33iwdnvg1r,
  _BoundsBuilder___get_ymin__impl__5n2e8j as _BoundsBuilder___get_ymin__impl__5n2e8j1x2fwruhjr6r5,
  Companion_getInstance as Companion_getInstanceeqp3ibr2vvu9,
  Companion_getInstance_0 as Companion_getInstance3rze5babd97ff,
  Companion_getInstance_1 as Companion_getInstance2yu48324co92b,
  Companion_getInstance_5 as Companion_getInstancenbeyvbsm21qs,
  Companion_getInstance_6 as Companion_getInstance1zxby1ngivg0d,
  Companion_getInstance_8 as Companion_getInstance3qti4zygy7usz,
  Companion_getInstance_10 as Companion_getInstance1bdwtq6rroayu,
  Companion_instance_11 as Companion_instanceu31qrc8c1r0r,
  Companion_getInstance_13 as Companion_getInstance23o88a0u6ly94,
  Companion_getInstance_14 as Companion_getInstance1j5nd3fbu9uao,
  Companion_getInstance_15 as Companion_getInstancewdpvtc2ehxkt,
  Companion_getInstance_17 as Companion_getInstance1yq7a1f60lp2k,
  Anchor2D as Anchor2D3ucppq7m9n3z8,
  Angle_between as Angle_between72970e1vlen9,
  Angle as Angle2itorpob18n08,
  BoundsBuilder as BoundsBuilder162uwsje56mvu,
  isAlmostEquals_0 as isAlmostEquals2qd88bwpjj4z5,
  isNotEmpty as isNotEmptyrwyeygz7izwg,
  IDoubleVectorList as IDoubleVectorListoa05cse3he2p,
  containsAll as containsAll194lepx84fvib,
  indexOf as indexOf3tp8bzbv46hci,
  iterator as iterator1sm8hwbj0nmg8,
  listIterator as listIteratorrk3szyua4uzm,
  listIterator_0 as listIterator3ooh2yjav3kr9,
  subList as subList2funs4qwcrhhq,
  IPointList as IPointListz7raskb2mrxa,
  Line2D as Line2D2pf35pcx71ncp,
  MarginInt as MarginInt3jiec8xsxkfd,
  Matrix4 as Matrix43neeu8v4zk4i7,
  MatrixTransform as MatrixTransform1wlsrhxt7473v,
  Matrix as Matrix1p940sdz227jj,
  RectangleInt as RectangleInt3lmu13ytuf5lk,
  Rectangle as Rectangle3q03woyn9k8x1,
  Scale as Scale2cm697xlulcp5,
  Size2D as Size2Dum5ayuyhhau7,
  SizeInt as SizeInte6w85oa6mz6v,
  Vector2D as Vector2D378fe5rov8fgw,
  Vector2I as Vector2I2k5512l4eeahb,
  Vector4F as Vector4F1clr35ctch8js,
  adjustFromUp as adjustFromUp1ak85cceintt4,
  get_degrees as get_degrees3czcd4ojw4i,
  interpolateAngleDenormalized as interpolateAngleDenormalized1hkwzk523mo1c,
  ortho as orthow9c0o91bw54n,
  outerCircle as outerCircle30hn5vvbpz9gu,
  get_radians as get_radians391vbqqjsolq6,
  get_scale as get_scale17gmsnxnqj6j9,
  scaled as scaled2eehd42i2trq9,
  toFloat as toFloat3b315y36g90cd,
  toInt as toIntp2twe4onfbic,
  toInt_0 as toIntu0rc68akxu7a,
  transformX as transformX33nszy4vzqsfy,
  transformY as transformY3ktoxhxwkzwk1,
  interpolate_1 as interpolatewhd2sgxffql5,
};
//endregion
